/* so-postcode — the customer's delivery postcode, and area-exact prices in the cart delivery row.
   Spec: docs/superpowers/specs/2026-09-25-postcode-delivery-design.md (smoke-organic repo).
   Postcode: one saved in this browser (localStorage soPostcode) wins over the signed-in account's
   default address (script[data-so-postcode-account], from so-postcode.liquid). A typed postcode or a
   suburb pick sends only the 4-digit postcode (suburb search sends the letters typed); "Use my location"
   (Task 18, Charl 2026-09-27) sends the device's point once to so-mail, which passes it to Bob Go and keeps
   only a ~1 km rounding — this browser stores only that rounded point, the place label and the nearest
   postcode, never the exact point. Prices: so-mail GET /delivery (Bob Go rates-at-checkout), cached 6 h in
   localStorage soDeliveryQuote (keyed on the postcode, or on the rounded point for a location quote). Page-wide delivery config (ladder, pickup days,
   quoteVersion) comes from script[data-so-delivery-config] (so-postcode.liquid, delivery_settings
   metaobject), and the cut-off, holidays and pre-order lead time from F2's data-so-dates-config via
   SO.dates.readConfig(), merged in config() — never literals. Date maths: SO.dates; pre-order phrase: SO.stock. Cart delivery blocks still carry their own
   data-so-cd-ladder/data-so-cd-basis attributes for their per-block basis. Pure functions are
   exported for node --test (scripts/tests/so-postcode.test.cjs in the smoke-organic repo). */
(function () {
  function ladderDiscount(basis, cfg) {
    if (!(basis >= cfg.floor)) return 0;
    return Math.min((Math.floor((basis - cfg.floor) / cfg.step) + 1) * cfg.inc, cfg.cap);
  }
  function netPrice(price, basis, cfg) { return Math.max(0, price - ladderDiscount(basis, cfg)); }
  // Smallest basis where the ladder covers `price`; null when price is above the cap (never free).
  function freeFrom(price, cfg) {
    if (price <= 0) return 0;
    if (price > cfg.cap) return null;
    return cfg.floor + (Math.ceil(price / cfg.inc) - 1) * cfg.step;
  }
  // Spec Rules 3/6: only pickup points within 5 km of the postcode ever reach the customer. bobbox/pargo
  // entries within range are merged into ONE 'pickup' option (mergePickup); farther (or unknown-distance)
  // points are dropped entirely — never shown, never cheapest, never the free-delivery nudge. Doorstep
  // options always count.
  var PICKUP_KM = 5;
  function mergePickup(options) {
    var near = [], rest = [];
    (options || []).forEach(function (o) {
      if (o.kind === 'bobbox' || o.kind === 'pargo') { if (typeof o.km === 'number' && o.km <= PICKUP_KM) near.push(o); }
      else rest.push(o);
    });
    if (!near.length) return rest;
    near.sort(function (a, b) { return a.price - b.price; });
    var nets = [];
    near.forEach(function (o) { if (nets.indexOf(o.kind) < 0) nets.push(o.kind); });
    nets.sort();                                                              // ['bobbox','pargo']
    var one = nets.length === 1;
    var merged = { kind: 'pickup', name: 'Pickup point', price: near[0].price, networks: nets, example: near[0].place,
      short: one ? (nets[0] === 'bobbox' ? 'Bob Box locker' : 'Pargo counter') : 'Pickup point' };
    return rest.concat([merged]);
  }
  function summarise(quote, basis, cfg) {
    var opts = mergePickup((quote && quote.options) || []);
    var list = opts.map(function (o) {
      return { o: o, net: netPrice(o.price, basis, cfg), freeAt: freeFrom(o.price, cfg) };
    });
    if (!list.length) return null;
    var cheapest = list.slice().sort(function (a, b) { return a.net - b.net || a.o.price - b.o.price; })[0] || null;
    var nets = list.map(function (x) { return x.net; });
    var next = null;
    list.forEach(function (x) { if (x.net > 0 && x.freeAt != null && (!next || x.freeAt < next.freeAt)) next = x; });
    var pickup = null;
    list.forEach(function (x) { if (!pickup && x.o.kind === 'pickup') pickup = x; });
    return { options: list, cheapest: cheapest, min: Math.min.apply(null, nets), max: Math.max.apply(null, nets),
             next: next, gap: next ? Math.ceil(next.freeAt - basis) : 0, pickup: pickup };
  }
  function rand(n) { return 'R' + String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function validPostcode(s) { var v = String(s == null ? '' : s).trim(); return /^\d{4}$/.test(v) ? v : null; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  // HTML-escaped option label: short name only — never place or km (those never reach the customer).
  function optLabel(x) { return esc(x.o.short); }
  // Dates: the store's ONE date engine is SO.dates (assets/so-dates.js, F2 — loaded `defer` in <head>, so it runs
  // before this script) and the pre-order phrase is SO.stock.shipText('pre', …) (assets/so-stock-state.js, F2).
  // This file keeps only DELIVERY dates (option promises, arrival dates, the cut-off state); business days,
  // holidays, dispatch day, formatting and the pre-order window all come from SO.dates. In node (tests) both are
  // required from this directory. Looked up at call time, never at parse time: if either is missing (failed to
  // load), config() returns null and every surface keeps its Liquid fallback — this script never throws for it.
  var NODE = typeof module === 'object' && module.exports && typeof require === 'function';
  var DATES = NODE ? require('./so-dates.js') : null, STOCK = NODE ? require('./so-stock-state.js') : null;
  function D() { return DATES || (typeof window !== 'undefined' && window.SO && window.SO.dates) || null; }
  function S() { return STOCK || (typeof window !== 'undefined' && window.SO && window.SO.stock) || null; }
  function sastParts(nowMs) { return D().sastParts(nowMs); }
  function todayOf(nowMs) { return D().todayOf(nowMs); }
  function isBusinessDay(t, hol) { return D().isBusinessDay(t, hol); }
  function addBusinessDays(t, n, hol) { return D().addBusinessDays(t, n, hol); }
  function dispatchDay(nowMs, cfg) { return D().dispatchDay(nowMs, cfg); }
  function holidaysCover(t, cfg) { return D().holidaysCover(t, cfg); }
  function fmtDay(t) { return D().fmtDay(t); }
  function fmtRange(a, b) { return D().fmtRange(a, b); }
  function leadDays(v) { return D().leadDays(v); }
  function preorderWindow(cfg, nowMs) { return D().preorderWindow(cfg, nowMs); }
  function nextBoundary(nowMs, cfg) { return D().nextBoundary(nowMs, cfg); }
  // A SAST day relative to `today` (both dayMs): "today" or the SHORT weekday ("Mon"). Task 14: never "tomorrow" —
  // the bar, the sheet banner and the cut-off card all say the same day the same way.
  function dayWord(t, today) { return D().dayWord(t, today); }
  // The pre-order ship phrase, F2 vocabulary (SO.stock owns it): full "ships around Mon 5 – Mon 12 Oct", compact
  // "ships around 5 – 12 Oct", bare drops the leading "ships " ("around …" / "in 5–10 business days"); '' when the
  // lead time can't be read (then callers keep their own plain "once your pre-order ships" wording).
  function preShip(cfg, nowMs, compact, bare) {
    var st = S();
    return st && cfg ? st.shipText('pre', cfg, nowMs >= 0 ? nowMs : null, !!compact, !!bare) || '' : '';
  }
  function upFirst(t) { return t ? t.charAt(0).toUpperCase() + t.slice(1) : t; }
  // Cut-off in minutes after midnight: SO.dates' reader sets cutoffMin (and cutoffHour); tests may pass cutoffHour.
  function cutoffMins(cfg) { return cfg && typeof cfg.cutoffMin === 'number' ? cfg.cutoffMin : cfg && cfg.cutoffHour > 0 ? cfg.cutoffHour * 60 : null; }
  // The cut-off as people read it: "7 AM", or "7:30 AM" for a half-hour cut-off (same minutes as the countdown).
  function cutLabel(cfg) {
    var m = cutoffMins(cfg); if (m == null) return null;
    var h = Math.floor(m / 60), mm = m % 60, h12 = h % 12 || 12;
    return h12 + (mm ? ':' + (mm < 10 ? '0' : '') + mm : '') + (h < 12 ? ' AM' : ' PM');
  }
  function promiseOf(o, cfg) {
    if (!o) return null;
    if (o.kind === 'pickup') return cfg.pickupDays ? { guaranteed: false, from: cfg.pickupDays[0], to: cfg.pickupDays[1] } : null;
    var n = o.name || '';
    if (/same day/i.test(n) && /guaranteed/i.test(n)) return { guaranteed: true, from: 0, to: 0 };
    if (/next day/i.test(n) && /guaranteed/i.test(n)) return { guaranteed: true, from: 1, to: 1 };
    var m = n.match(/(\d+)\s*to\s*(\d+)\s*days/i);
    return m ? { guaranteed: false, from: +m[1], to: +m[2] } : null;
  }
  function deliveryDates(o, nowMs, cfg) {
    var pr = promiseOf(o, cfg); if (!pr) return null;
    var d = dispatchDay(nowMs, cfg);
    var from = addBusinessDays(d, pr.from, cfg.holidays), to = addBusinessDays(d, pr.to, cfg.holidays);
    if (!holidaysCover(d, cfg) || !holidaysCover(to, cfg)) return null;       // Rule 10
    return { guaranteed: pr.guaranteed, from: from, to: to };
  }
  function cutoffState(nowMs, cfg) {
    var p = sastParts(nowMs), today = todayOf(nowMs), d = dispatchDay(nowMs, cfg);
    var before = d === today;
    var nextLabel = (before ? 'today' : dayWord(d, today)) + ' ' + cutLabel(cfg);   // Task 14: never "tomorrow"
    return { countdownMin: before ? (cutoffMins(cfg) - (p.h * 60 + p.min)) : null, nextLabel: nextLabel, dispatch: d };
  }
  // Pre-order kept: an option's arrival relative to the day the order ships (no dates).
  function preorderWhen(o, cfg) {
    var pr = promiseOf(o, cfg); if (!pr) return null;
    var span = function (a, b) { return (a === b ? a : a + '–' + b) + ' day' + (a === b && a === 1 ? '' : 's'); };
    if (o.kind === 'pickup') return 'About ' + span(pr.from, pr.to) + ' after it ships';
    if (pr.guaranteed) return pr.from === 0 ? 'Arrives the day it ships' : 'Arrives the business day after it ships';
    return span(pr.from, pr.to) + ' after it ships';
  }

  // Delivery sheet model (pure; the browser part only turns it into HTML). Every text decision for
  // the sheet lives here so it's tested: option names, badges, sub-lines, dates, prices, the cut-off
  // banner, the pickup-only sentence and the discount card. Strings are plain text, NOT escaped —
  // the renderer escapes them. `cfg` is the full page config {ladder, cutoffHour, pickupDays, holidays}.
  // Display name: the checkout name before " — ", minus "(Guaranteed)/(Estimated)" (the badge says it).
  function displayName(o) {
    if (o.kind === 'pickup') return o.short;
    return String(o.short || o.name || '').replace(/\s*\((guaranteed|estimated)\)\s*$/i, '');
  }
  function isMergedPickup(o) { return o.kind === 'pickup' && (o.networks || []).length > 1; }   // Bob Box + Pargo
  // Options cheapest first (ties: lower list price) — the order the sheet lists them in.
  function byNet(list) { return list.slice().sort(function (a, b) { return a.net - b.net || a.o.price - b.o.price; }); }
  // The fastest Guaranteed option (fewest promised days) in a summarise() list, or null.
  function fastestGuaranteed(list, cfg) {
    var fast = null, fastPr = null;
    list.forEach(function (x) { var pr = promiseOf(x.o, cfg); if (pr && pr.guaranteed && (!fastPr || pr.from < fastPr.from)) { fast = x; fastPr = pr; } });
    return fast;
  }
  function iconOf(o) {
    if (o.kind === 'pickup') return o.networks && o.networks.length === 1 && o.networks[0] === 'pargo' ? 'shop' : 'box';
    var n = o.name || '';
    if (/same day|next day/i.test(n)) return 'bolt';
    if (/express|overnight|2-day|2 day/i.test(n)) return 'truck';
    return 'door';
  }
  // Task 25 trim: one short sub-line for every pickup row — "Bob Box or Pargo" (+ the nearest pickup place, when
  // known, as "· e.g. Bothasig Square"). Rule 6/8: never a distance; a named point only as "e.g. …".
  function pickupSub(o) {
    return 'Bob Box or Pargo' + (o.example ? ' · e.g. ' + o.example : '');
  }
  function pickupOnlyLine(o, code) {
    var n = o.networks || [], one = n.length === 1;
    var what = one ? (n[0] === 'pargo' ? 'pickup counters' : 'pickup lockers') : 'pickup points';
    var where = one ? (n[0] === 'pargo' ? 'at the counter' : 'in the locker') : 'at the pickup point';
    return 'At ' + code + ' couriers deliver to ' + what + ' only. Your parcel waits ' + where + ' and you get a message when it’s ready.';
  }
  function sheetMsg(kind, code) {
    if (kind === 'loading') return 'Finding delivery options for ' + code + '…';
    if (kind === 'failed') return 'We couldn’t load prices for ' + code + ' right now. Your options will show at checkout.';
    if (kind === 'empty') return 'No delivery options found for ' + code + '. Check the postcode, or see your options at checkout.';
    if (kind === 'noconfig') return 'Prices for ' + code + ' will show at checkout.';
    return '';
  }
  // opts.preorder (whole cart incl. a pre-order): no cut-off banner; each option's line is relative to the ship day
  // ("2–3 days after it ships", when.lead null = plain), and one line above the options with the ship window
  // ("Your order ships when the pre-order stock arrives, around Mon 5 – Mon 12 Oct."; preorderDates = the bold
  // part). Window unknown (lead time unreadable, no holiday cover) → "Dates start once your pre-order ships.".
  // so-mail marks a menu it couldn't confirm with Bob Go `{ options: [], unconfirmed: true }` (~15 postcodes): NOT
  // "no options" — every surface treats it like no config (generic Liquid copy, no figures, no pickup-only line).
  function isUnconfirmed(q) { return !!(q && q.unconfirmed === true); }
  function sheetModel(quote, basis, cfg, nowMs, code, opts) {
    opts = opts || {};
    if (!cfg || !cfg.ladder || isUnconfirmed(quote)) return { state: 'noconfig', code: code, message: sheetMsg('noconfig', code) };
    var L = cfg.ladder, s = summarise(quote, basis, L);
    if (!s) return { state: 'empty', code: code, message: sheetMsg('empty', code) };
    var list = byNet(s.options), hp = headPick(s, cfg);
    var many = list.length > 1, anyFree = hp.frees.length > 0;
    var hasPickup = list.some(function (x) { return x.o.kind === 'pickup'; });
    var pl = opts.place || null, located = !!(pl && pl.src === 'location' && pl.code === code);
    var rows = list.map(function (x) {
      var o = x.o, pr = promiseOf(o, cfg), dd = opts.preorder ? null : deliveryDates(o, nowMs, cfg);
      var pending = x.net > 0 && x.freeAt != null, isGoal = pending && x === hp.target;
      var pw = opts.preorder ? preorderWhen(o, cfg) : null;
      var when = pw ? { lead: null, text: pw } : !dd ? null : dd.guaranteed ? { lead: 'Arrives', text: fmtDay(dd.from) } : { lead: 'Around', text: fmtRange(dd.from, dd.to) };
      return {
        kind: o.kind, icon: iconOf(o), name: displayName(o),
        badge: pr ? (pr.guaranteed ? 'Guaranteed' : 'Estimated') : null,
        // Task 25 trim: doorstep rows carry no sub-line at all; only pickup keeps one.
        sub: o.kind === 'pickup' ? pickupSub(o) : null,
        when: when,
        was: x.net < o.price ? rand(o.price) : null,
        from: isMergedPickup(o) && x.net > 0,
        now: x.net === 0 ? 'Free' : rand(x.net), free: x.net === 0,
        // Task 22 (design A) → Task 25 trim: every pending row still says "Free from R999", but the "R800 to go"
        // text and the progress bar now appear ONLY on the goal row (the nearest one, `hp.target`) — other rows
        // show just the muted free-from line.
        freeFrom: pending ? 'Free from ' + rand(x.freeAt) : null,
        toGo: isGoal ? rand(Math.ceil(x.freeAt - basis)) + ' to go' : null,
        fraction: isGoal ? Math.round(Math.max(0, Math.min(1, basis / x.freeAt)) * 1000) / 1000 : null,
        goal: isGoal,
        // One flag, the footer row's pick (Task 18): nothing free → "Cheapest to 8005" on the cheapest; something
        // free → "Fastest free to 8005" on the FASTEST free option (all free → the fastest of all).
        cheapest: many && !anyFree && x === list[0],
        fastestFree: many && anyFree && x === hp.x,
        flag: !many ? null : !anyFree ? (x === list[0] ? 'Cheapest to ' + code : null) : x === hp.x ? 'Fastest free to ' + code : null
      };
    });
    // Cut-off banner: only when the postcode has a Guaranteed option (the fastest one is named).
    var fast = fastestGuaranteed(list, cfg);
    var banner = null;
    if (fast && !opts.preorder && cutLabel(cfg)) {
      var cs = cutoffState(nowMs, cfg), p = sastParts(nowMs), today = Date.UTC(p.y, p.m, p.day);
      var word = dayWord(cs.dispatch, today);                               // the same word as the announcement bar
      var fd = deliveryDates(fast.o, nowMs, cfg);
      banner = { title: 'Order by ' + cutLabel(cfg) + ' ' + word + ' · ' + displayName(fast.o) + (fd ? ' ' + fmtDay(fd.from) : ''),
                 sub: 'Orders placed before ' + cutLabel(cfg) + ' on a business day ship that morning.' };
    }
    var pickupOnly = list.length === 1 && list[0].o.kind === 'pickup' ? pickupOnlyLine(list[0].o, code) : null;
    var pre = opts.preorder ? preShip(cfg, nowMs, false, true) : '';          // F2: "around Mon 5 – Mon 12 Oct" | "in 5–10 business days" | ''
    // Task 25 trim: the "Your delivery discount" card is gone. In its place, ONE small line under the options
    // list (`discountLine`) — the ladder rule and the postcode's free-from figure said once, never twice. Only
    // with 2+ options and at least one that can go free (same gate the old card used).
    var discountLine = null, maxAt = 0;
    list.forEach(function (x) { if (x.freeAt > maxAt) maxAt = x.freeAt; });
    if (many && maxAt > 0) {
      var off = ladderDiscount(basis, L), capped = off >= L.cap;
      var allCan = list.every(function (x) { return x.freeAt != null; });
      var nextAt = basis < L.floor ? L.floor : L.floor + L.step * (Math.floor((basis - L.floor) / L.step) + 1);
      var every = allCan ? ' · every option to ' + code + ' free from ' + rand(maxAt) + '.' : null;
      if (hp.all) {
        discountLine = 'Every option to ' + code + ' is free with this order.';
      } else if (!off) {
        discountLine = rand(L.inc) + ' off from ' + rand(L.floor) + ', then ' + rand(L.inc) + ' more per ' + rand(L.step) +
          (every || ', up to ' + rand(L.cap) + '.');
      } else {
        discountLine = rand(off) + ' off delivery with this order' +
          (capped ? '' : ' · next ' + rand(L.inc) + ' off at ' + rand(nextAt)) + (every || '.');
      }
    }
    return {
      state: 'ok', code: code,
      sub: basis > 0 ? 'With what’s in your cart now · ' + rand(basis) : 'Prices before any delivery discount',
      banner: banner, pickupOnly: pickupOnly, rows: rows, discountLine: discountLine,
      preorder: !opts.preorder ? null : pre ? 'Your order ships when the pre-order stock arrives, ' + pre + '.' : 'Dates start once your pre-order ships.',
      preorderDates: pre ? pre.replace(/^(around|in) /, '') : null,
      // Task 25 trim: one short footnote; "pickup point" only when a pickup option is listed, and the location
      // privacy sentence stays for a place that came from "Use my location".
      foot: 'Checkout confirms the exact ' + (hasPickup ? 'pickup point and ' : '') + 'price.' +
            (located ? ' Your location is used only to find nearby options; this device keeps just the area (about 1 km).' : '')
    };
  }

  // ---- places (Task 18: suburb search + "Use my location") — pure ----
  // A place = what the customer chose: {code, label (suburb, or null), src 'typed'|'search'|'location'|'account',
  // pt ('-33.92,18.39' — ONLY for 'location': the point rounded to 2 decimals, ≈1 km; the exact point is never kept)}.
  var PT_RE = /^-?\d{1,2}\.\d{2},-?\d{1,3}\.\d{2}$/;
  function roundCoord(v) { return Math.round(v * 100) / 100 + 0; }                       // + 0: no "-0"
  function pointKey(lat, lng) { return roundCoord(lat).toFixed(2) + ',' + roundCoord(lng).toFixed(2); }
  function cleanLabel(v) { var t = typeof v === 'string' ? v.replace(/\s+/g, ' ').trim() : ''; return t && t.length <= 40 ? t : null; }
  // The stored soPostcode entry → a place (null when there is no valid postcode).
  function placeOf(entry) {
    if (!entry || !validPostcode(entry.code)) return null;
    var src = entry.src === 'location' || entry.src === 'search' || entry.src === 'account' ? entry.src : 'typed';
    var pt = src === 'location' && typeof entry.pt === 'string' && PT_RE.test(entry.pt) ? entry.pt : null;
    if (src === 'location' && !pt) src = 'typed';                               // a location place without its point is just a postcode
    var out = { code: validPostcode(entry.code), label: src === 'typed' ? null : cleanLabel(entry.label), src: src, pt: pt };
    if (src === 'search' && entry.ap === 1) out.approx = true;   // Task 31: a GUESSED postcode (shown "Near ...")
    return out;
  }
  // The signed-in customer's saved addresses (data-so-account-addresses: [{code, area, default}]), pure: valid ZA
  // postcodes only, ONE row per postcode (delivery is priced per postcode, so two addresses in 7441 are one
  // choice), labelled with the first address's city, "default" if any address there is; the default first.
  function accountAddresses(list) {
    var out = [], seen = {};
    (Array.isArray(list) ? list : []).forEach(function (a) {
      var code = a && validPostcode(a.code); if (!code) return;
      var area = cleanLabel(a.area) || null, k = code;
      if (seen[k]) { if (a.default) { seen[k].default = true; if (area) seen[k].area = area; } if (!seen[k].area && area) seen[k].area = area; return; }
      seen[k] = { code: code, area: area, default: !!a.default }; out.push(seen[k]);
    });
    return out.filter(function (x) { return x.default; }).concat(out.filter(function (x) { return !x.default; }));
  }
  // What goes into localStorage for a place: postcode, label, source and (location only) the ROUNDED point.
  function placeEntry(place, ts) {
    var e = { code: place.code, ts: ts };
    if (place.src === 'search' || place.src === 'location' || place.src === 'account') { e.src = place.src; if (cleanLabel(place.label)) e.label = cleanLabel(place.label); }
    if (place.src === 'location' && place.pt && PT_RE.test(place.pt)) e.pt = place.pt;
    if (place.src === 'search' && place.approx === true) e.ap = 1;
    return e;
  }
  // Quote cache key: the rounded point for a location place (its quote is for THAT spot, more exact than the
  // postcode's), else the postcode.
  function quoteKey(place) { return place ? (place.pt ? 'pt:' + place.pt : place.code) : null; }
  function locateUrl(endpoint, lat, lng, v) {
    return endpoint + '?lat=' + encodeURIComponent(String(lat)) + '&lng=' + encodeURIComponent(String(lng)) + (v ? '&v=' + encodeURIComponent(v) : '');
  }
  // /delivery?lat&lng answer → the place to save ({near: {postcode, label}}), or null when it's unusable.
  function placeFromNear(data, pt) {
    var n = data && data.near, code = n && validPostcode(n.postcode);
    if (!code || !PT_RE.test(pt || '') || !data || !Array.isArray(data.options)) return null;
    return { code: code, label: cleanLabel(n.label), src: 'location', pt: pt };
  }
  // Postcode-sheet input: "8005" / "80" → digits (code once 4); letters → a place-name query (min 2 characters).
  function inputKind(v) {
    var t = String(v == null ? '' : v).replace(/\s+/g, ' ').trim();
    if (!t) return { kind: 'empty', code: null, query: null };
    if (/^[\d ]+$/.test(t)) { var d = t.replace(/ /g, ''); return { kind: 'digits', code: /^\d{4}$/.test(d) ? d : null, digits: d.slice(0, 4), query: null }; }
    return { kind: 'text', code: null, query: t.length >= 2 ? t.slice(0, 64) : null };
  }
  // Task 31: `s` = the Google session token (sessionToken()), sent on every search — so-mail then answers
  // {places, google} and may top a short own list up with Google rows. Without it: the legacy bare array.
  function placesUrl(endpoint, q, s) { return endpoint + '/places?q=' + encodeURIComponent(q) + (s ? '&s=' + encodeURIComponent(s) : ''); }
  // A Google row's postcode (so-mail /delivery/place → Place Details), with the same session token.
  function placeUrl(endpoint, id, s) { return endpoint + '/place?id=' + encodeURIComponent(id) + (s ? '&s=' + encodeURIComponent(s) : ''); }
  // Task 31 — Google Places fallback (pure). One UUID v4 per postcode-sheet opening (and a new one after a pick):
  // Google bills the searches + the one Place Details of a session as one. `rnd(n)` → n random bytes (tests).
  var UUID4_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;
  function sessionToken(rnd) {
    var b = null, i, h = '';
    try { if (!rnd && typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') { var u = String(crypto.randomUUID()).toLowerCase(); if (UUID4_RE.test(u)) return u; } } catch (e) { /* fall through */ }
    try { b = rnd ? rnd(16) : crypto.getRandomValues(new Uint8Array(16)); } catch (e) { b = null; }
    if (!b || b.length < 16) { b = []; for (i = 0; i < 16; i++) b.push(Math.floor(Math.random() * 256)); }
    b = Array.prototype.slice.call(b, 0, 16);
    b[6] = (b[6] & 0x0f) | 0x40; b[8] = (b[8] & 0x3f) | 0x80;
    for (i = 0; i < 16; i++) { h += (b[i] + 0x100).toString(16).slice(1); if (i === 3 || i === 5 || i === 7 || i === 9) h += '-'; }
    return h;
  }
  var PLACE_ID_RE = /^[A-Za-z0-9_-]{10,300}$/;
  // Task 20 (Charl's iPhone, 2026-09-28) — the postcode sheet on phones (pure).
  // Where focus goes when the postcode sheet opens: touch devices (coarse pointer, or no hover) → the sheet title
  // ('title'): iOS opens the keyboard for a programmatic focus but never scrolls the sheet for it, so the keyboard
  // hid the content; a field the customer taps themselves IS scrolled into view. Fine pointer → the field ('input').
  function focusTarget(flags) { return flags && (flags.coarse || flags.hoverNone) ? 'title' : 'input'; }
  // No "Show options" button: what the field's value does on `trigger` ('input' — typed, pasted or filled by the
  // iOS postcode chip; 'enter'). Exactly 4 digits → {act:'code', code} (looked up even when it isn't a known
  // postcode); Enter on text with suggestions → {act:'pick'} (the active one, else the first); Enter otherwise →
  // {act:'hint', text}; anything else while typing → null (keep typing / suggestions update).
  var PC_HINT = 'Choose a suburb from the list, or type a 4-digit postcode';
  function proceedAction(value, trigger, sugCount) {
    var k = inputKind(value);
    if (k.code) return { act: 'code', code: k.code };
    if (trigger !== 'enter') return null;
    if (k.kind === 'text' && sugCount > 0) return { act: 'pick' };
    return { act: 'hint', text: PC_HINT };
  }
  // The postcode sheet's order: "Use my location" (primary, only with geolocation) · an "or" divider · the field.
  // No geolocation → the field alone (no divider).
  function postcodeParts(geo) { return geo ? ['locate', 'or', 'field'] : ['field']; }
  // /delivery/places answer → at most 8 {label ('Sea Point, Cape Town'), name ('Sea Point'), postcode}, deduped.
  // Task 31: the answer is the legacy bare array or {places, google}; a Google row (source 'google') becomes
  // {label, name, postcode: null, placeId} — its postcode comes on pick (/delivery/place).
  function suggestionList(data) {
    var out = [], seen = {};
    var rows = Array.isArray(data) ? data : data && Array.isArray(data.places) ? data.places : [];
    rows.forEach(function (x) {
      if (!x || out.length >= 8) return;
      if (x.source === 'google') {
        var gl = typeof x.label === 'string' ? x.label.replace(/\s+/g, ' ').trim() : '', name = gl.split(',')[0].trim();
        if (!gl || gl.length > 60 || !cleanLabel(name) || typeof x.placeId !== 'string' || !PLACE_ID_RE.test(x.placeId) || seen['g|' + gl.toLowerCase()]) return;
        seen['g|' + gl.toLowerCase()] = 1;
        out.push({ label: gl, name: cleanLabel(name), postcode: null, placeId: x.placeId });
        return;
      }
      var code = validPostcode(x.postcode), label = cleanLabel(x.label);
      if (!code || !label || seen[label + '|' + code]) return;
      seen[label + '|' + code] = 1;
      out.push({ label: label, name: label.split(',')[0].trim(), postcode: code });
    });
    return out;
  }
  // The list + whether to show "Powered by Google" under it: the answer said google:true AND a Google row survived.
  function suggestionModel(data) {
    var items = suggestionList(data);
    return { items: items, google: !!(data && !Array.isArray(data) && data.google === true) && items.some(function (x) { return !!x.placeId; }) };
  }
  // One suggestion row: own rows carry the postcode chip; a Google row has no postcode yet → a subtle "›".
  function sugRow(x) { return { label: x.label, chip: x.postcode || null, more: !x.postcode }; }
  // The suggestion_pick beacon: which list the pick came from ('own' | 'google'); a Google row has no postcode yet.
  function pickEvent(x) { return x && x.placeId ? { pc: null, code: 'google' } : { pc: x ? x.postcode : null, code: 'own' }; }
  // /delivery/place answer → {code, label, approx} or null (then the customer adds the 4 digits). The label is OUR
  // name for the postcode (ownLabel), never Google's place name, so nothing from Google is kept on the device.
  // approx (a name/centroid guess) → the place is shown "Near ...", like "Use my location".
  function placeResult(data) {
    var code = data && validPostcode(data.postcode);
    if (!code) return null;
    return { code: code, label: cleanLabel(data.ownLabel), approx: data.approx === true };
  }
  var PC_PLACEHOLDER = 'e.g. Sea Point or 7441';
  function needPostcode(name) { return 'Add the 4-digit postcode for ' + (cleanLabel(name) || 'this place'); }
  // "Use my location" failure → the inline message, by GeolocationPositionError.code.
  function geoMessage(code) {
    if (code === 1) return 'Location is blocked for this site. Allow it in your browser settings, or type your postcode or suburb.';
    if (code === 2) return 'Your device couldn’t find your location. Type your postcode or suburb instead.';
    if (code === 3) return 'Finding your location took too long. Try again, or type your postcode or suburb.';
    return 'Location isn’t available. Type your postcode or suburb instead.';
  }
  // Task 21 — the postcode sheet opened with a place already set (the Change path), pure. currentLine(place) → the
  // "current" line under the intro, or null with no postcode (the sheet is then exactly as in Task 20):
  //   location → {name:'Near Pinelands', code:'7405', note:'from your location'}; search → {name:'Sea Point', code:'8005'};
  //   typed → {code:'7405'}; account → {code:'7405', note:'from your account'}. `text` joins them with ' · ' and `aria`
  //   is what the live region says on open. Built from the stored place only (label + postcode): nothing new is kept.
  function currentLine(place) {
    var code = place && validPostcode(place.code);
    if (!code) return null;
    var label = cleanLabel(place.label);
    var near = place.src === 'location' || place.approx === true;          // Task 31: an approximate pick reads like a location
    var name = label && (place.src === 'location' || place.src === 'search' || place.src === 'account') ? (near ? 'Near ' : '') + label : null;
    var note = place.src === 'location' ? 'from your location' : place.src === 'account' ? 'from your account' : place.approx === true && !name ? 'approximate' : null;
    var text = [name, code, note].filter(Boolean).join(' · ');
    return { name: name, code: code, note: note, text: text,
             aria: 'Delivering to ' + [name, code, note].filter(Boolean).join(', ') + '. Search below to choose somewhere else.' };
  }
  // The location button: "Update my location" (secondary) when the current place came from the location, else
  // "Use my location" (primary).
  function locateButton(place) {
    return place && place.src === 'location' && validPostcode(place.code) ? { text: 'Update my location', secondary: true }
                                                                          : { text: 'Use my location', secondary: false };
  }
  function placeFromSuggestion(sug) { return { code: sug.postcode, label: sug.name, src: 'search', pt: null }; }
  // Delivery sheet title: always "Delivery to [8005]" (never cut). A place label goes on the subtitle line instead
  // (`place`): suburb pick → "Sea Point", location → "Near Sea Point"; only for the place's own postcode.
  // subLine(place, sub) → "Sea Point · with what’s in your cart now · R1,286" (the renderer may ellipsize it).
  function sheetTitle(place, code) {
    var own = place && place.code === code && place.label && (place.src === 'search' || place.src === 'location');
    return { lead: 'Delivery to', code: code, place: own ? (place.src === 'location' || place.approx === true ? 'Near ' : '') + place.label : null };
  }
  function subLine(placeText, sub) {
    if (!placeText) return sub || '';
    return sub ? placeText + ' · ' + sub.charAt(0).toLowerCase() + sub.slice(1) : placeText;
  }

  // Cart footer row model (pure; Task 19 = design X, theme-mockups-postcode/cart-row-X-oneline.html). ONE 44px
  // line: "Economy [7441] Free ┆ Same Day free · R213 to go ›", the card's bottom edge = the progress bar (only
  // with a goal). `s` = summarise(quote, basis, ladder) for the CURRENT postcode; `cfg` = the page config (dates
  // only when it's present — Rule 10: no config / no holiday cover → no date).
  // Headline: nothing free yet → the cheapest option ("Pickup", from R39, R49 struck) and the goal is ITS
  // free-from. Something free → the FASTEST free option ("Same Day", Free, R145 struck) and the goal is the
  // faster option that goes free soonest ("Same Day free · R213 to go"); none left → no goal. Everything free
  // (2+ options) → no goal, `allFree` "All 3 free" on the right.
  // The line drops dates / the ship window and "N more options" (the sheet has them); `when` and `more` stay in
  // the model for the aria-label, which says everything once. opts.preorder (whole cart incl. a pre-order, i.e.
  // not "shipnow") → `when` = the ship window "Ships around Mon 5 – Mon 12 Oct"; unknown → "Once your pre-order
  // ships" (never dates).
  // Names: `name` = full (aria, and the line from 380px): merged two-network pickup → "Pickup"; one network →
  // named plainly ("Pargo counter"); doorstep → the display name. `line` = the phone form (only one-network
  // pickups differ: "Pargo", "Bob Box"). Word tiers are CSS container queries on the renderer, not the model.
  // Strings are plain text, NOT escaped.
  function footName(o) { return isMergedPickup(o) ? 'Pickup' : displayName(o); }
  // Fastest first: Same Day/Next Day, then Express, then Economy/other door, then pickup; within a tier
  // Guaranteed first, then the earlier promised end/start, then the dearer option.
  function speedKey(o, cfg) {
    var ic = iconOf(o), tier = o.kind === 'pickup' ? 3 : ic === 'bolt' ? 0 : ic === 'truck' ? 1 : 2;
    var pr = cfg ? promiseOf(o, cfg) : null;
    return [tier, pr && pr.guaranteed ? 0 : 1, pr ? pr.to : 99, pr ? pr.from : 99, -o.price];
  }
  function bySpeed(list, cfg) {
    return list.map(function (x) { return { x: x, k: speedKey(x.o, cfg) }; }).sort(function (a, b) {
      for (var i = 0; i < a.k.length; i++) if (a.k[i] !== b.k[i]) return a.k[i] - b.k[i];
      return 0;
    }).map(function (y) { return y.x; });
  }
  function footLine(o) {
    var n = o.networks || [];
    return o.kind === 'pickup' && n.length === 1 ? (n[0] === 'pargo' ? 'Pargo' : 'Bob Box') : footName(o);
  }
  // The headline pick every surface shares (footer row, pre-order pills, delivery sheet flag + goal line), from
  // `s` = summarise(…): nothing free → x = the cheapest, target = it (when it can go free); something free → x =
  // the FASTEST free option, target = the faster option that goes free soonest (none → null). all = every
  // option free.
  function headPick(s, cfg) {
    var list = s.options, x = s.cheapest, target = null;
    var frees = list.filter(function (y) { return y.net === 0; });
    if (!frees.length) {
      if (x.freeAt != null && x.freeAt > 0) target = x;
    } else {
      var sp = bySpeed(list, cfg);
      x = sp.filter(function (y) { return y.net === 0; })[0];
      sp.slice(0, sp.indexOf(x)).forEach(function (y) {
        if (y.net > 0 && y.freeAt != null && (!target || y.freeAt < target.freeAt)) target = y;
      });
    }
    return { x: x, target: target, frees: frees, all: frees.length === list.length };
  }
  function footerModel(s, basis, cfg, nowMs, code, opts) {
    if (!s || !s.cheapest) return null;
    opts = opts || {};
    var hp = headPick(s, cfg), list = s.options, x = hp.x, target = hp.target, frees = hp.frees;
    var o = x.o, name = footName(o);
    var dd = cfg && !opts.preorder ? deliveryDates(o, nowMs, cfg) : null;
    var pre = opts.preorder ? upFirst(preShip(cfg, nowMs)) : '';            // F2: "Ships around Mon 5 – Mon 12 Oct"
    var when = opts.preorder ? (pre || 'Once your pre-order ships') : !dd ? null : dd.guaranteed ? 'Arrives ' + fmtDay(dd.from) : 'Around ' + fmtRange(dd.from, dd.to);
    var n = list.length - 1, all = n > 0 && frees.length === list.length;
    var more = all ? 'all ' + list.length + ' free' : n > 0 ? n + ' more option' + (n === 1 ? '' : 's') : null;
    var free = x.net === 0, from = isMergedPickup(o) && !free;
    var was = x.net < o.price ? rand(o.price) : null, now = free ? 'Free' : rand(x.net);
    var goal = null;
    if (target) {
      var left = Math.ceil(target.freeAt - basis);
      goal = { name: footName(target.o), line: footLine(target.o), at: rand(target.freeAt),
               togo: rand(left) + ' to go', long: left >= 1000,      // 4+ digits: the renderer drops "free" <380px
               pct: Math.min(100, Math.round(basis / target.freeAt * 1000) / 10) };
    }
    var cap = function (t) { return t.charAt(0).toUpperCase() + t.slice(1); };
    return {
      name: name, line: footLine(o), code: code, when: when, more: more,
      was: was, from: from, now: now, free: free,
      allFree: all ? 'All ' + list.length + ' free' : null,
      goal: goal,
      aria: name + ' to ' + code + ', ' + (from ? 'from ' : '') + (free ? 'free' : now) + (was ? ', was ' + was : '') + '.' +
            (goal ? ' ' + goal.name + ' is free from ' + goal.at + ', ' + goal.togo + '.' : '') +
            (more ? ' ' + cap(more) + '.' : '') + (when ? ' ' + when + '.' : '') + ' See all delivery options'
    };
  }

  // Announcement bar model (pure). `s` = summarise(quote, 0, ladder) for the CURRENT postcode — the bar is
  // site-wide and does not follow the cart, so prices are before any delivery discount ("from"). `cfg` = the
  // page config. With a Guaranteed option, day-aware from `nowMs` (SAST, business days, holidays — the sheet's
  // cut-off logic): "Order by 7 AM today · Same Day today" / "… Tue · Same Day Tue" / "… Mon · Same Day Mon";
  // Next Day names its arrival weekday, the business day after dispatch ("Order by 7 AM today · Next Day Tue").
  // Never "tomorrow" (Task 14). No `nowMs` or no holiday cover (Rule 10) → the plain "Same Day if you order by 7 AM" (no day).
  // Without a Guaranteed option: at the cart basis, the fastest free option ("Economy is free") or the cheapest
  // option's name + "from R…" (net of the delivery discount). Null (bar left as it is) when there is
  // no summary or no config. `short` = the phone form ("Same Day Mon · by 7 AM Mon"; = text when there is no
  // day-aware form). Plain text, NOT escaped. The bar re-renders at nextBoundary(nowMs, cfg).
  // opts.preorder (the visible cart keeps a pre-order, Task 13 fix 1): no Same Day / Next Day claim — the ship
  // window instead: "Your order ships around Mon 5 – Mon 12 Oct" (phones "Ships around 5 – 12 Oct");
  // window unknown → "Ships once your pre-order arrives" (phones "Ships once pre-order arrives").
  function announceModel(s, cfg, code, nowMs, opts) {
    if (!s || !s.cheapest || !cfg) return null;
    if (opts && opts.preorder) {
      // F2 phrase (SO.stock.shipText): "Your order ships around Mon 5 – Mon 12 Oct". Phones: the compact form, no
      // weekdays ("Ships around 5 – 12 Oct", "28 Sep – 12 Oct") — the weekday form (191px) overflows the 175px left
      // at 375px (Task 14 check). No phrase (lead time unreadable) → our plain wording.
      var pf = preShip(cfg, nowMs), pc = preShip(cfg, nowMs, true);
      var pt = pf ? 'Your order ' + pf : 'Ships once your pre-order arrives';
      var ps = pc ? upFirst(pc) : 'Ships once pre-order arrives';
      return { code: code, text: pt, short: ps, aria: 'Delivering to ' + code + '. ' + pt + '. See delivery options' };
    }
    var fast = cfg.cutoffHour > 0 ? fastestGuaranteed(byNet(s.options), cfg) : null;
    var x = s.cheapest, text, short;
    if (fast) {
      var hr = cutLabel(cfg), pr = promiseOf(fast.o, cfg);
      text = displayName(fast.o) + ' if you order by ' + hr;
      if (nowMs >= 0) {
        var p = sastParts(nowMs), today = Date.UTC(p.y, p.m, p.day), d = dispatchDay(nowMs, cfg), arr = addBusinessDays(d, pr.from, cfg.holidays);
        if (holidaysCover(d, cfg) && holidaysCover(arr, cfg)) {
          var dw = dayWord(d, today);
          text = 'Order by ' + hr + ' ' + dw + ' · ' + displayName(fast.o) + ' ' + dayWord(arr, today);
          // Phones: the promise first, then the cut-off; the cut-off's day only when it isn't today (it must fit
          // 175px at 375px): "Same Day today · by 7 AM", "Same Day Mon · by 7 AM Mon", "Next Day Wed · by 7 AM Tue".
          short = displayName(fast.o) + ' ' + dayWord(arr, today) + ' · by ' + hr +
            (dw === 'today' ? '' : ' ' + dw);
        }
      }
    } else {
      // Ruling 23 (amended): `s` is at the cart basis (the slot's and footer's) — something free → the FASTEST free
      // option ("Economy is free", the slot's pick); else the cheapest net price ("Economy from R88"). Basis not
      // known yet (opts.basisUnknown) → null: the bar stays as rendered rather than show list prices.
      if (opts && opts.basisUnknown) return null;
      var fr = s.options.filter(function (y) { return y.net === 0; });
      text = fr.length ? footName(bySpeed(fr, cfg)[0].o) + ' is free' : displayName(x.o) + ' from ' + rand(x.net);
    }
    return { code: code, text: text, short: short || text, aria: 'Delivering to ' + code + '. ' + text + '. See delivery options' };
  }

  // Product page Delivery card (pure): the state choice for [data-so-pdp-delivery] + its link line, on every
  // placement (PDP + the site-wide footer strip). Plain text, NOT escaped; `labelChip`/`cueChip` = the renderer
  // appends the postcode chip. `open` = the sheet so-pdp-info.js opens ('postcode' | 'delivery').
  //   no config                → null: the Liquid "Delivery from R73 · Rates & collection" + the old modal stay
  //   no postcode              → "Your delivery price" · "Add postcode ›", opens the postcode sheet (Task 12:
  //                              R73 is not a price anyone pays — pickup starts lower — so we ask instead)
  //   pending (`lookup` 'pending': quote in flight, or the cart basis not read yet) → the same label as no postcode
  //                              (no flash while typing → quote), link line "Options to [chip]"
  //   failed (`lookup` 'failed') or no options (s empty) → "Delivery to [chip]" · "Change postcode ›", opens the
  //                              delivery sheet (its own failed / no-options state with Change and Try again)
  //   quote + basis            → ONE label line: nothing free yet → "Delivery from R{cheapest net}"; something free →
  //                              the FASTEST free option (same pick as the cart footer headline and the pre-order
  //                              pills) + " is free", free: true (saved green) · "Options to [chip]"
  // `s` = summarise(quote, cartBasis, ladder) for the CURRENT postcode.
  // lookup 'unconfirmed' (isUnconfirmed quote) → null, exactly like no config.
  function pdpCardModel(s, cfg, code, lookup) {
    if (!cfg || lookup === 'unconfirmed') return null;
    if (!code) return { state: 'none', code: null, label: 'Your delivery price', labelChip: false, free: false,
                        cue: 'Add postcode', cueChip: false, open: 'postcode', aria: 'Add your postcode to see your delivery price' };
    if (lookup === 'pending') return { state: 'pending', code: code, label: 'Your delivery price', labelChip: false, free: false,
                                       cue: 'Options to', cueChip: true, open: 'delivery', aria: 'Delivery to ' + code + '. See delivery options' };
    if (lookup === 'failed' || !s || !s.cheapest) {
      var failed = lookup === 'failed';
      return { state: failed ? 'failed' : 'empty', code: code, label: 'Delivery to', labelChip: true, free: false,
               cue: 'Change postcode', cueChip: false, open: 'delivery',
               aria: 'Delivery to ' + code + '. ' + (failed ? 'Prices didn’t load' : 'No delivery options found') + '. Change postcode' };
    }
    var free = s.cheapest.net === 0, name = free ? footName(bySpeed(s.options, cfg).filter(function (y) { return y.net === 0; })[0].o) : null;
    var label = free ? name + ' is free' : 'Delivery from ' + rand(s.cheapest.net);
    return { state: 'ok', code: code, label: label, labelChip: false, free: free, cue: 'Options to', cueChip: true, open: 'delivery',
             aria: 'Delivery to ' + code + ', ' + (free ? label : 'from ' + rand(s.cheapest.net)) + '. See delivery options' };
  }

  // Product page "with this" line (pure). basisNow = the cart subtotal now, basisWith = it plus this item.
  // Only when an option that is NOT free at basisNow IS free at basisWith; several → the FASTEST one
  // (Ruling 11). Returns {name, total, now} (plain text: option name, the new cart total, its price now)
  // or null — the line stays hidden. `cfg` = the page config {ladder, …}.
  function withThisModel(quote, basisNow, basisWith, cfg) {
    if (!cfg || !cfg.ladder || !(basisNow >= 0) || !(basisWith > basisNow)) return null;
    var a = summarise(quote, basisNow, cfg.ladder), b = summarise(quote, basisWith, cfg.ladder);
    if (!a || !b) return null;
    // Same quote → same options in the same order (mergePickup is deterministic): match by position.
    var flips = b.options.filter(function (y, i) { return y.net === 0 && a.options[i].net > 0; });
    if (!flips.length) return null;
    var x = bySpeed(flips, cfg)[0], was = a.options[b.options.indexOf(x)];
    return { name: footName(x.o), total: rand(basisWith), now: rand(was.net) };
  }

  // Cart add-on row (pure): the same question as "with this" — does adding the row's price (rands) to the
  // cart at `basis` make an option free that isn't free now? Several → the FASTEST (Ruling 11). Returns
  // {name, code} (plain text, rendered "✓ {name} to [code] becomes free") or null (the Liquid gain stays).
  function addonModel(quote, basis, price, cfg, code) {
    if (!code || !(price > 0)) return null;
    var m = withThisModel(quote, basis, basis + price, cfg);
    return m ? { name: m.name, code: code } : null;
  }

  // Pre-order choice effect (pure), picked like the footer row / PDP card so the pill and the row agree:
  // something free at that choice's basis → the FASTEST free option ("Economy free"); nothing free → the
  // cheapest with its price ("Economy R13"; a merged two-network pickup says "from", as the footer row does).
  // `s` = summarise(quote, basis, ladder) for the CURRENT postcode; `cfg` = the page config (speed order).
  // Null when there is no summary. Plain text, NOT escaped.
  function effectModel(s, cfg) {
    if (!s || !s.cheapest) return null;
    var x = headPick(s, cfg).x, free = x.net === 0;
    return { text: footName(x.o) + (free ? ' free' : (isMergedPickup(x.o) ? ' from ' : ' ') + rand(x.net)), free: free };
  }

  // Cart basis pick (pure): the first visible block with a basis → {basis, preorder}; else null. `preorder` may be
  // a function (read lazily, only for the block picked).
  function pickCartBasis(blocks) {
    for (var i = 0; i < (blocks || []).length; i++) {
      var b = blocks[i];
      if (b && !b.hidden && b.basis != null && b.basis >= 0) return { basis: b.basis, preorder: !!(typeof b.preorder === 'function' ? b.preorder() : b.preorder) };
    }
    return null;
  }

  // Header postcode slot (pure; Task 13, concept E; line 2 = WHAT IT COSTS since Task 14 — the bar says WHEN).
  // Line 1 = the place: the dashed "Postcode" tag with no postcode, else the chip. Line 2 = ONE price fact at
  // the cart basis (a kept pre-order: the 'all' basis, the same rule), never a day word:
  //   something free → the FASTEST free option (the footer row's pick): "Economy free", "Pickup free";
  //   nothing free   → the cheapest net price: "from R49", "from R19";
  //   no postcode / failed / no options, or a line over SLOT_MAX characters → "Delivery prices".
  // Pickup is named "Pickup" here (no room for "Bob Box locker"); the aria-label says it in full ("Delivery to
  // 7441, from R49. See delivery options"). `long` = the desktop line (the same text: the button is a fixed
  // 170px). lookup: null (quote + basis) | 'pending' | 'failed'; `s` = summarise(quote, basis, ladder) for the
  // CURRENT postcode. `nowMs`/`opts` are unused (kept for callers). No config → null (the Liquid link stays as
  // rendered, Ruling 22). Plain text, NOT escaped.
  var SLOT_MAX = 13;
  function slotName(o) { return o.kind === 'pickup' ? 'Pickup' : displayName(o); }
  function slotFact(s, cfg) {
    var frees = s.options.filter(function (y) { return y.net === 0; });
    if (frees.length) {
      var f = bySpeed(frees, cfg)[0], t1 = slotName(f.o) + ' free';
      return t1.length <= SLOT_MAX ? { line: t1, full: footName(f.o) + ' free', free: true } : null;
    }
    var t2 = 'from ' + rand(s.cheapest.net);
    return t2.length <= SLOT_MAX ? { line: t2, full: 'from ' + rand(s.cheapest.net), free: false } : null;
  }
  function slotModel(code, lookup, s, cfg, nowMs, opts) {
    if (!cfg) return null;                                   // no config: the Liquid link stays as rendered (Ruling 22)
    opts = opts || {};
    var ask = 'Delivery prices';
    if (!code) return { state: 'none', code: null, tag: 'Postcode', empty: true, line: ask, long: 'Add postcode',
                        free: false, open: 'postcode', aria: 'Add your postcode for delivery prices' };
    if (lookup === 'pending') return { state: 'pending', code: code, tag: code, empty: false, line: null, long: null, free: false,
                                       open: 'delivery', aria: 'Delivery to ' + code + '. Checking delivery prices' };
    // Unconfirmed menu (isUnconfirmed): the generic line, no figure and no "didn't load" claim.
    if (lookup === 'unconfirmed') return { state: 'ok', code: code, tag: code, empty: false, line: ask, long: ask, free: false, open: 'delivery',
                                           aria: 'Delivery to ' + code + '. See delivery options or change postcode' };
    var fact = lookup !== 'failed' && s && s.cheapest ? slotFact(s, cfg) : null;
    if (!fact) {
      var failed = lookup === 'failed' || !s || !s.cheapest;
      return { state: failed ? 'failed' : 'ok', code: code, tag: code, empty: false, line: ask, long: ask, free: false, open: 'delivery',
               aria: 'Delivery to ' + code + '. ' + (failed ? 'Prices didn’t load. ' : '') + 'See delivery options or change postcode' };
    }
    return { state: 'ok', code: code, tag: code, empty: false, line: fact.line, long: fact.line, free: fact.free, open: 'delivery',
             aria: 'Delivery to ' + code + ', ' + fact.full + '. See delivery options' };
  }

  // The delivery sheet's pinned next-step footer (pure; Task 13). `origin` = where the sheet was opened from
  // ('header' | 'bar' | 'pdp' | 'page' | 'cart' | 'addons' | 'invite'); `cart` = {count, total (rands)}: seeded
  // at open from what the page already knows (count from the header bubble, total unknown = null), then /cart.js.
  // Never waits: the footer renders with the view's first paint (no jump). count unknown (null / no cart) → the
  // two-button layout with a plain "View cart" (it opens the drawer either way); count 0 → one button; count > 0
  // → "View cart", plus " · R1,875" once the total is known (the fixed 1fr 1fr row keeps its height).
  // `onCartPage` = this is /cart. Buttons: act 'close' (closes the sheet) | 'cart' (closes it and opens the
  // cart drawer). `saved` = the "Saved on this device · the header now shows [7441]" line may show (never
  // from the cart: the customer changed it there on purpose).
  var CART_ORIGINS = ['cart', 'addons', 'invite'];
  function sheetFooterModel(origin, cart, onCartPage) {
    if (CART_ORIGINS.indexOf(origin) >= 0 || onCartPage) {
      return { saved: false, buttons: [{ act: 'close', label: 'Back to cart', primary: true, icon: 'back' }] };
    }
    var n = cart && typeof cart.count === 'number' && cart.count >= 0 ? cart.count : null;   // null = unknown
    if (n === 0) return { saved: true, buttons: [{ act: 'close', label: 'Continue shopping', primary: true }] };
    var fig = n && typeof cart.total === 'number' && cart.total >= 0 ? rand(cart.total) : null;
    return { saved: true, buttons: [
      { act: 'close', label: 'Continue shopping', primary: false },
      { act: 'cart', label: 'View cart', figure: fig, primary: true, icon: 'cart',
        aria: 'View cart' + (n ? ', ' + n + ' item' + (n === 1 ? '' : 's') : '') + (fig ? ', ' + fig : '') }] };
  }

  // Empty cart cut-off card (pure). `s` = summarise(quote, 0, ladder) for the CURRENT postcode (an empty cart:
  // list prices). Only when the postcode has a Guaranteed option (the fastest one is named) and the config has
  // a cut-off hour; else null (the Liquid empty cart stays as it is). All times SAST; hour, business days and
  // holidays from `cfg`.
  //   mode 'countdown' — before the cut-off on a business day: "2 h 58 min left" + a midnight → cut-off bar.
  //   mode 'next'      — otherwise: "Next cut-off Mon 7 AM" + the fastest option's arrival date.
  //   Rule 10: the holiday list doesn't cover the dispatch day → no countdown and no date, plain wording only.
  // `parts` is the sentence under the headline as segments {t, b (bold), chip}; `text` is the same, flat.
  // `pickup` = the quiet line: the cheapest option at list price ("Pickup to [7441] · from R49 · free from R699").
  // Strings are plain text, NOT escaped.
  function cutoffCardModel(s, cfg, nowMs, code) {
    if (!s || !s.cheapest || !cfg || !(cfg.cutoffHour > 0) || !code) return null;
    var fast = fastestGuaranteed(byNet(s.options), cfg);
    if (!fast) return null;
    var H = cfg.cutoffHour, hr = cutLabel(cfg), name = displayName(fast.o);
    var p = sastParts(nowMs), today = Date.UTC(p.y, p.m, p.day);
    var cs = cutoffState(nowMs, cfg), covered = holidaysCover(cs.dispatch, cfg);
    var sameDay = promiseOf(fast.o, cfg).from === 0, dd = covered ? deliveryDates(fast.o, nowMs, cfg) : null;
    var m = { code: code, name: name, top: fmtDay(today) + ' · ' + ('0' + p.h).slice(-2) + ':' + ('0' + p.min).slice(-2),
              mode: 'next', minsLeft: null, big: null, small: null, bar: null, parts: null };
    if (!covered) {
      m.big = 'Order before ' + hr;
      m.parts = [{ t: 'Order before ' }, { t: hr, b: 1 }, { t: ' on a business day for ' }, { t: name, b: 1 }, { t: ' to ' }, { chip: 1 },
                 { t: '. It ships that morning.' }];
      m.aria = name + ' to ' + code + ': order before ' + hr + ' on a business day';
    } else if (cs.countdownMin != null) {
      var left = cs.countdownMin, h = Math.floor(left / 60), mi = left % 60;
      m.mode = 'countdown'; m.minsLeft = left;
      m.big = h && mi ? h + ' h ' + mi + ' min' : h ? h + ' h' : mi + ' min';
      m.small = 'left';
      m.bar = { frac: Math.round((H * 60 - left) / (H * 60) * 1000) / 1000, from: 'Midnight', to: hr + ' cut-off' };
      m.parts = [{ t: 'Order before ' }, { t: hr, b: 1 }, { t: ' for ' }, { t: name, b: 1 }, { t: ' to ' }, { chip: 1 },
                 { t: '. It ships this morning and arrives ' + (sameDay ? 'today' : dd ? fmtDay(dd.from) : 'the next business day') + '.' }];
      m.aria = name + ' to ' + code + ': order before ' + hr + ' today';
    } else {
      var passed = isBusinessDay(today, cfg.holidays) && p.h >= H;       // today had a cut-off and it's gone
      m.big = 'Next cut-off ' + cs.nextLabel;
      m.parts = (passed ? [{ t: 'Today’s ' + hr + ' cut-off has passed. ' }] : []).concat([
        { t: 'Order before ' }, { t: cs.nextLabel, b: 1 }, { t: ' for ' }, { t: name, b: 1 }, { t: ' to ' }, { chip: 1 },
        { t: dd ? '. It arrives ' + fmtDay(dd.from) + '.' : '.' }]);
      m.aria = name + ' to ' + code + ': next cut-off ' + cs.nextLabel;
    }
    m.text = m.parts.map(function (x) { return x.chip ? code : x.t; }).join('');
    var c = s.cheapest, from = isMergedPickup(c.o) && c.o.price > 0;
    m.pickup = { icon: iconOf(c.o), name: footName(c.o), code: code,
                 price: c.o.price > 0 ? rand(c.o.price) : 'Free', from: from,
                 freeFrom: c.o.price > 0 && c.freeAt != null ? 'free from ' + rand(c.freeAt) : null };
    m.pickup.text = m.pickup.name + ' to ' + code + ' · ' + (from ? 'from ' : '') + m.pickup.price + (m.pickup.freeFrom ? ' · ' + m.pickup.freeFrom : '');
    return m;
  }

  // Quote cache (pure). Theme-side quote version (config quoteVersion, so-postcode.liquid): bumping it makes every
  // browser refetch — the localStorage entry stores the version it was fetched under (a mismatch, incl. old
  // entries with none, is a miss) and the /delivery URL carries &v= so the browser HTTP cache (max-age up to the
  // server TTL) misses too. `entry` = the stored {code, ts, v, data}; returns the data or null.
  function quoteVersion(cfg) { return cfg && cfg.quoteVersion != null ? String(cfg.quoteVersion) : ''; }
  function quoteUrl(endpoint, code, v) { return endpoint + '?postcode=' + encodeURIComponent(code) + (v ? '&v=' + encodeURIComponent(v) : ''); }
  // `key` = quoteKey(place): the postcode, or 'pt:-33.92,18.39' for a location quote (entry.pt set).
  function cachedQuote(entry, key, v, nowMs, ttl) {
    var ek = entry ? (entry.pt ? 'pt:' + entry.pt : entry.code) : null;
    if (!entry || ek !== key || !entry.data || (entry.v == null ? '' : String(entry.v)) !== v) return null;
    if (!(Array.isArray(entry.data.options) && entry.data.options.length) || !(nowMs - entry.ts < ttl)) return null;
    return entry.data;
  }

  // Belt and braces (so-mail already does this): no stored quote keeps a sub-km pickup distance or Bob Go's
  // "(approx. 0.4 km)" — with a location quote those would pin down the shopper's spot, and the sheet says this
  // device keeps just the area.
  function coarseQuote(q) {
    var out = {}; for (var k in q) if (Object.prototype.hasOwnProperty.call(q, k)) out[k] = q[k];
    out.options = q.options.map(function (o) {
      var c = {}; for (var j in o) if (Object.prototype.hasOwnProperty.call(o, j)) c[j] = o[j];
      if (typeof c.km === 'number') c.km = Math.round(c.km);
      if (typeof c.name === 'string') c.name = c.name.replace(/\s*\(approx[^)]*\)\s*/gi, ' ').replace(/\s+/g, ' ').trim();
      return c;
    });
    return out;
  }
  // fetch() with a hard timeout so a hung so-mail call lands in the caller's own failed state instead of
  // spinning forever. Browsers without AbortController just skip the abort (the fetch still runs, unbounded).
  function fetchTimeout(url, opts, ms) {
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var o = opts || {};
    if (ctrl) o = { credentials: o.credentials, signal: ctrl.signal };
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, ms) : null;
    return fetch(url, o).then(function (r) { clearTimeout(timer); return r; },
      function (e) { clearTimeout(timer); throw e; });
  }
  var api = { coarseQuote: coarseQuote, fetchTimeout: fetchTimeout, quoteVersion: quoteVersion, quoteUrl: quoteUrl, cachedQuote: cachedQuote, ladderDiscount: ladderDiscount, netPrice: netPrice, freeFrom: freeFrom, summarise: summarise, rand: rand,
              displayName: displayName, sheetModel: sheetModel, sheetMsg: sheetMsg, footerModel: footerModel, announceModel: announceModel, isUnconfirmed: isUnconfirmed,
              pdpCardModel: pdpCardModel, withThisModel: withThisModel, addonModel: addonModel, effectModel: effectModel, cutoffCardModel: cutoffCardModel, pickCartBasis: pickCartBasis,
              slotModel: slotModel, sheetFooterModel: sheetFooterModel, accountAddresses: accountAddresses, headPick: headPick,
              geoMessage: geoMessage, subLine: subLine, pointKey: pointKey, placeOf: placeOf, placeEntry: placeEntry, quoteKey: quoteKey, locateUrl: locateUrl, placeFromNear: placeFromNear,
              inputKind: inputKind, placesUrl: placesUrl, placeUrl: placeUrl, sessionToken: sessionToken, suggestionModel: suggestionModel, sugRow: sugRow, pickEvent: pickEvent, placeResult: placeResult, PC_PLACEHOLDER: PC_PLACEHOLDER, needPostcode: needPostcode, focusTarget: focusTarget, currentLine: currentLine, locateButton: locateButton, proceedAction: proceedAction, postcodeParts: postcodeParts, suggestionList: suggestionList, placeFromSuggestion: placeFromSuggestion, sheetTitle: sheetTitle,
              validPostcode: validPostcode, optLabel: optLabel, mergePickup: mergePickup,
              sastParts: sastParts, isBusinessDay: isBusinessDay, addBusinessDays: addBusinessDays, dispatchDay: dispatchDay,
              holidaysCover: holidaysCover, promiseOf: promiseOf, deliveryDates: deliveryDates, fmtDay: fmtDay,
              fmtRange: fmtRange, cutoffState: cutoffState, cutLabel: cutLabel, footLine: footLine, nextBoundary: nextBoundary, leadDays: leadDays, preorderWindow: preorderWindow };
  if (typeof module === 'object' && module.exports) { module.exports = api; return; }

  // Page config = our data-so-delivery-config (ladder, pickupDays, quoteVersion) + the F2 dates config read by
  // SO.dates' own reader from data-so-dates-config (layout/theme.liquid): cutoff → cutoffMin/cutoffHour, holidays,
  // preorderLeadTime → preorderDays, lowAt. Null (Liquid fallbacks everywhere) without SO.dates/SO.stock or either tag.
  function config(){ try {
    var dt = D(), st = S();
    if (!dt || !st || typeof dt.readConfig !== 'function') return null;
    var c = JSON.parse(document.querySelector('script[data-so-delivery-config]').textContent);
    if (!(c.ladder && c.ladder.step > 0 && c.ladder.inc > 0)) return null;
    var d = dt.readConfig();
    if (!d) return null;
    c.cutoffMin = d.cutoffMin; c.cutoffHour = typeof d.cutoffMin === 'number' ? d.cutoffHour : 0;   // unreadable cut-off → no cut-off copy anywhere
    c.holidays = d.holidays || [];
    c.preorderLeadTime = d.preorderLeadTime; c.preorderDays = d.preorderDays; c.lowAt = d.lowAt;
    return c;
  } catch (e) { return null; } }

  if (window.soPostcodeBound) return;
  window.soPostcodeBound = true;

  var ENDPOINT = 'https://links.smokeorganic.co.za/delivery';
  var KEY = 'soPostcode', QKEY = 'soDeliveryQuote', TTL = 6 * 3600 * 1000;
  var quote = null, quoteFor = null, loading = null, failedFor = null;
  // Task 28: the tracking module (assets/so-tracking.js, loaded first) — every call is guarded, so this file
  // never breaks when it's missing (old cached HTML, a blocked script).
  function TR() { return window.SO && window.SO.tracking; }

  function readLS(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function writeLS(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* storage blocked: works for this page only */ } }

  function accountPostcode() {
    var el = document.querySelector('script[data-so-postcode-account]');
    if (!el) return null;
    try { return validPostcode(JSON.parse(el.textContent)); } catch (e) { return null; }
  }
  var savedAddrs = null;                                   // parsed once per page (the list only changes on a new page)
  function savedAddresses() {
    if (savedAddrs) return savedAddrs;
    var el = document.querySelector('script[data-so-account-addresses]');
    try { savedAddrs = el ? accountAddresses(JSON.parse(el.textContent)) : []; } catch (e) { savedAddrs = []; }
    return savedAddrs;
  }
  // The customer's place (placeOf): the one saved in this browser, else the account's postcode.
  function currentPlace() {
    return placeOf(readLS(KEY)) || accountPlace();
  }
  // The account's default address as a place (its suburb as the label when the saved address has one).
  function accountPlace() {
    var code = accountPostcode(); if (!code) return null;
    var d = savedAddresses().filter(function (a) { return a.code === code && a.default; })[0];
    return { code: code, label: d ? d.area : null, src: 'account', pt: null };
  }
  function current() { var pl = currentPlace(); return pl ? pl.code : null; }
  // Every surface works off the postcode; the quote in use for it is keyed on the place (quoteKey): a location
  // place's quote (for the rounded point) stays the quote for its postcode — it is the more exact one.
  function keyFor(code) { var pl = currentPlace(); return pl && pl.code === code ? quoteKey(pl) : code; }
  function hasQuote(code) { return !!(quote && code && quoteFor === keyFor(code)); }
  function failed(code) { return !!code && failedFor === keyFor(code); }

  function hasOptions(q) { return !!(q && Array.isArray(q.options) && q.options.length); }
  function isPending(code) { return !!code && !hasQuote(code) && !failed(code); }

  // Stored quote entry: {code, pt (location quotes only — the ROUNDED point), ts, v, data}.
  function storeQuote(key, code, v, data) {
    if (!hasOptions(data)) return;               // never keep an empty menu for 6 h: the server holds it for 30 min only
    var e = { code: code, ts: Date.now(), v: v, data: coarseQuote(data) };
    if (key.indexOf('pt:') === 0) e.pt = key.slice(3);
    writeLS(QKEY, e);
  }
  function fetchQuote(code) {
    var key = keyFor(code);
    if (quoteFor === key && quote) return Promise.resolve(quote);
    var v = quoteVersion(cfgOnce()), entry = readLS(QKEY), hit = cachedQuote(entry, key, v, Date.now(), TTL);
    if (hit) { quote = hit; quoteFor = key; return Promise.resolve(quote); }
    // An entry from another quote version (incl. old ones stored without v) is never used: drop it once.
    if (entry && (entry.v == null ? '' : String(entry.v)) !== v) { try { localStorage.removeItem(QKEY); } catch (e) { /* storage blocked */ } }
    if (loading && loading.key === key) return loading.p;
    // A location place whose quote has aged out is re-asked with its ROUNDED point (all this browser keeps).
    var url = key.indexOf('pt:') === 0 ? locateUrl(ENDPOINT, key.slice(3).split(',')[0], key.slice(3).split(',')[1], v) : quoteUrl(ENDPOINT, code, v);
    var t0 = Date.now();
    var p = fetchTimeout(url, { credentials: 'omit' }, 8000)
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (data) {
        if (!data || !Array.isArray(data.options)) throw new Error('bad quote');
        quote = data; quoteFor = key; failedFor = null;
        storeQuote(key, code, v, data);
        var t = TR(); if (t) t.send('quote_ok', { pc: code, ms: Date.now() - t0 });
        return data;
      })
      .catch(function (e) {
        failedFor = key;
        var t = TR(); if (t) { t.send('quote_fail', { pc: code, code: t.quoteFailCode(e) }); t.clarityEvent('so_quote_fail'); }
        return null;
      })
      .then(function (d) { loading = null; return d; });
    loading = { key: key, p: p };
    return p;
  }

  function ladderOf(block) {
    var p = (block.getAttribute('data-so-cd-ladder') || '').split(',').map(Number);
    if (p.length !== 4 || p.some(function (n) { return !(n >= 0); }) || !(p[1] > 0) || !(p[2] > 0)) return null;
    return { floor: p[0], step: p[1], inc: p[2], cap: p[3] };
  }
  function basisOf(block) { var b = parseFloat(block.getAttribute('data-so-cd-basis')); return b >= 0 ? b : null; }

  function netText(net) { return net === 0 ? 'Free' : rand(net); }

  // Footer row HTML from footerModel (escaped here) — design X, ONE 44px line:
  //   [name (to) chip] [(struck) (from) price] ┆ [goal line (free) (from R…) · R… to go] ›   + bottom-edge bar
  // Nothing wraps or ellipsizes: words drop out by the footer's width instead (container `so-cd-foot` on the
  // area, so-cart-delivery.css): __w1 ("to", the struck price, full names) from 380px, __w3 (the goal's
  // "from R1,699") from 460px, __w2 (the goal's "free") hidden below 320px. The chip is the shared
  // .so-pc-chip (so-delivery-sheet.css); icons come from the sheet's ICONS via ico(key, class) — only called at
  // fill time, after ICONS is set. All visible text is aria-hidden: the aria-label says it once, in full.
  function footerHtml(m) {
    var W1 = 'so-cd-foot__w1', g = m.goal;
    var nm = m.line !== m.name
      ? '<span class="' + W1 + '">' + esc(m.name) + '</span><span class="so-cd-foot__w1n">' + esc(m.line) + '</span>'
      : esc(m.name);
    var price = (m.was ? '<s class="so-cd-foot__was ' + W1 + '">' + esc(m.was) + '</s>' : '') +
      (m.from ? '<span class="so-cd-foot__from">from</span>' : '') +
      '<b class="so-cd-foot__now' + (m.free ? ' is-free' : '') + '">' + esc(m.now) + '</b>';
    var right = g
      ? '<span class="so-cd-foot__g" aria-hidden="true"><span class="so-cd-foot__gl">' + esc(g.line) + '<span class="so-cd-foot__w2"> free</span>' +
        '<span class="so-cd-foot__w3"> from ' + esc(g.at) + '</span> ·</span><b class="so-cd-foot__togo">' + esc(g.togo) + '</b></span>'
      : m.allFree ? '<span class="so-cd-foot__g" aria-hidden="true"><span class="so-cd-foot__ok">' + ico('check', 'so-cd-foot__svg') + esc(m.allFree) + '</span></span>' : '';
    // A 4+ digit to-go ("R1,180 to go") drops the goal's "free" below 380px (so-cart-delivery.css .is-long).
    var long = g && g.long;
    return '<button type="button" class="so-cd-foot' + (g ? ' has-goal' : '') + (long ? ' is-long' : '') + (right ? '' : ' no-right') + '" data-so-cd-foot aria-haspopup="dialog" aria-label="' + esc(m.aria) + '">' +
      '<span class="so-cd-foot__hd" aria-hidden="true"><span class="so-cd-foot__nm">' + nm + '<span class="' + W1 + '"> to</span></span>' +
      '<span class="so-pc-chip">' + esc(m.code) + '</span></span>' +
      '<span class="so-cd-foot__p" aria-hidden="true">' + price + '</span>' +
      right +
      ico('chev', 'so-cd-foot__chev') +
      (g ? '<span class="so-cd-foot__track" aria-hidden="true"><i style="width:' + g.pct + '%"></i></span>' : '') +
      '</button>';
  }

  // Measured safety net under the container-query tiers: the tiers fit every design state with room to spare,
  // but a long amount ("Economy R118 ┆ Economy free · R1,180 to go" in a 300px column) or a wider fallback font
  // could still push the goal under the chevron. Then drop words, never ellipsize: .is-tight1 = the 300px copy
  // (no "free"/"from R…"/struck price/"to"), .is-tight2 = the goal's name too (only "R1,180 to go" stays; the
  // aria-label keeps it all). Re-run when the footer's width changes (the drawer measures 0 while closed) and
  // when web fonts finish loading (the first fill often measures the fallback font, which is wider).
  function refitFeet() { document.querySelectorAll('[data-so-cd-area].is-foot').forEach(fitFoot); }
  if (document.fonts) {
    if (document.fonts.ready) document.fonts.ready.then(refitFeet);
    if (document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', refitFeet);
  }
  function fitFoot(area) {
    var btn = area.querySelector('.so-cd-foot'), g = btn && btn.querySelector('.so-cd-foot__g');
    if (!g) return;
    var over = function () {
      var have = g.getBoundingClientRect().width; g.style.flex = 'none';
      var need = g.getBoundingClientRect().width; g.style.flex = '';
      return need - have > 0.5;
    };
    // Observe first: a row filled while the drawer is closed (width 0) must refit when it opens.
    if (!area.__soFit && window.ResizeObserver) {
      var w0 = area.getBoundingClientRect().width;
      area.__soFit = new ResizeObserver(function () {
        var w = area.getBoundingClientRect().width;
        if (w !== w0) { w0 = w; fitFoot(area); }
      });
      area.__soFit.observe(area);
    }
    btn.classList.remove('is-tight1', 'is-tight2');
    if (!area.getBoundingClientRect().width) return;
    if (over()) { btn.classList.add('is-tight1'); if (over()) btn.classList.add('is-tight2'); }
  }

  // Pre-order kept: this block prices the WHOLE cart (variant 'all', not the "shipnow" copy) and the cart has
  // pre-order units (the same per-line spans so-preorder-cart.js counts) → dispatch waits for the pre-order.
  // Counted within the block's own cart (the drawer, or the /cart section), not the whole page.
  function preorderKept(block) {
    if (block.getAttribute('data-so-cd-variant') === 'shipnow') return false;
    var n = 0, scope = block.closest('cart-drawer') || block.closest('.shopify-section') || document;
    scope.querySelectorAll('.so-preorder-line-data').forEach(function (el) { n += Number(el.getAttribute('data-so-preorder-units')) || 0; });
    return n > 0;
  }

  // The cart's delivery amount as the visible cart row prices it: the first visible delivery block's basis and
  // pre-order state — the 'all' block when Keep is chosen, the "shipnow" one (in-stock items, never pre-order)
  // when Remove is. So a sheet opened from the bar / PDP card, and the card's "from R…", match the row and
  // checkout instead of the whole-cart /cart.js subtotal. Null when no cart block is on the page (then /cart.js).
  function visibleCart() {
    var bs = document.querySelectorAll('[data-so-cart-delivery]');
    return pickCartBasis(Array.prototype.map.call(bs, function (b) {
      return { hidden: b.hidden, basis: basisOf(b), preorder: function () { return preorderKept(b); } };
    }));
  }

  // Fill one delivery block. The Liquid row stays exactly as rendered unless we have a real quote for the
  // CURRENT postcode: then it is hidden (kept in the DOM) and [data-so-cd-area] holds ONE footer row + bar.
  // Every other state (no postcode, pending, failed, no options) shows the Liquid row again and puts the
  // area's server-rendered content back first, so no figure for another postcode or basis can linger.
  function fill(block) {
    var area = block.querySelector('[data-so-cd-area]');
    var lad = ladderOf(block), basis = basisOf(block), code = current(), pre = preorderKept(block);
    if (!area || !lad || basis == null) return;
    var key = (code || '-') + '|' + basis + '|' + (pre ? 'po' : '') + (hasQuote(code) ? 'q' + quoteFor : failed(code) ? 'x' : 'p');
    if (block.getAttribute('data-so-pc-done') === key) return;
    block.setAttribute('data-so-pc-done', key);
    var row = block.querySelector('.so-cart-delivery__row');
    if (area.__soPcOrig == null) area.__soPcOrig = area.innerHTML;   // the Liquid "See delivery prices…" button
    function restore(html) {
      if (row) row.hidden = false;
      area.classList.remove('is-foot');
      area.innerHTML = html == null ? area.__soPcOrig : html;
    }
    if (!code) { restore(); return; }                    // keep the "See delivery prices for your postcode" button
    var change = '<button type="button" class="so-cart-delivery__pc" data-so-cd-open data-so-cd-change data-so-cd-focus="postcode">Change</button>';
    if (failed(code)) { restore('<p class="so-cart-delivery__note">Delivering to ' + code + ' · ' + change + '</p>'); return; }
    if (!hasQuote(code)) { restore(); fetchQuote(code).then(fillAll); return; }
    if (isUnconfirmed(quote)) { restore(); return; }        // like no config: the Liquid row, never "No delivery options"
    if (!cfgOnce()) { restore(); return; }                   // no config yet: the Liquid row, never postcode prices
    var s = summarise(quote, basis, lad);
    var m = s && footerModel(s, basis, cfgOnce(), Date.now(), code, { preorder: pre });
    if (!m) {
      restore('<p class="so-cart-delivery__note">No delivery options found for ' + code + '. Check the postcode, or see your options at checkout. ' + change + '</p>');
      return;
    }
    area.innerHTML = footerHtml(m);
    area.classList.add('is-foot');                        // the container (word tiers) before measuring
    fitFoot(area);
    if (row) row.hidden = true;
  }

  // Task 28 (tracking-contract.md, section C): the hidden `_so_delivery` cart attribute, built from the same
  // model the cart row uses — footerModel's headline pick (headPick), on the basis the visible cart row prices
  // (visibleCart(), same as the sheet/PDP card use). Only fires when there's a real quote for the current
  // postcode; the write itself is debounced and de-duped against the cart's own attribute inside so-tracking.js
  // (never an extra /cart.js fetch — it reads lastCartFull, populated by cartInfo()/the theme's cart events).
  function syncDeliveryAttr() {
    var t = TR();
    if (!t) return;
    var code = current();
    if (!code) { t.syncDeliveryAttr(lastCartFull, { pc: null }); return; }
    var cfg = cfgOnce();
    if (!hasQuote(code) || isUnconfirmed(quote) || !cfg) return;   // nothing certain yet: leave the attribute as it is
    var vc = visibleCart();
    if (!vc || vc.basis == null || vc.basis < 0) return;
    var s = summarise(quote, vc.basis, cfg.ladder);
    if (!s) return;
    var hp = headPick(s, cfg), pl = currentPlace();
    t.syncDeliveryAttr(lastCartFull, { src: pl && pl.src, pc: code, head: footLine(hp.x.o), price: hp.x.net, basis: vc.basis });
  }

  function fillAll() {
    var bs = document.querySelectorAll('[data-so-cart-delivery]');
    bs.forEach(fill);
    rowLabels();
    fillAddons();
    fillEffects();
    fillCutoff();
    if (bs.length) inviteCheck();
    syncDeliveryAttr();
  }

  // ---- cart add-on rows (snippets/so-cart-addons.liquid) ----
  // Each row carries data-so-ca-price (cents) and an empty [data-so-ca-pc] slot; the <details> carries the
  // bases it was rendered on (data-so-ca-all, and data-so-ca-shipnow for a mixed pre-order cart). The basis
  // follows the pre-order radio exactly like applyBasis() in so-cart-addons.js ("Remove" → shipnow). With a
  // quote for the CURRENT postcode and an option that newly becomes free, the slot reads "✓ Same Day to [7441]
  // becomes free" and the row's Liquid gain line ("Gets you R30 off delivery") is hidden by the row's
  // .has-pc class (a class, not [hidden], so applyBasis() can't bring it back). Every other case: the slot is
  // empty and hidden, the Liquid lines stay exactly as rendered. Called from fillAll(), i.e. also from the
  // DOM observer, so a re-rendered add-ons block is filled before it paints (no flash of the Liquid line).
  function addonsVariant() {
    var r = document.querySelector('.so-preorder-cart__radio:checked');
    return r && r.value === 'shipnow' ? 'shipnow' : 'all';
  }
  function fillAddons() {
    var boxes = document.querySelectorAll('[data-so-cart-addons]');
    if (!boxes.length) return;
    var code = current(), q = curQuote(), cfg = cfgOnce(), v = addonsVariant();
    boxes.forEach(function (box) {
      var raw = box.getAttribute('data-so-ca-' + v), basis = raw ? parseInt(raw, 10) / 100 : NaN;
      var rows = box.querySelectorAll('.so-cart-addons__row[data-so-ca-price]'), n = 0, shown = 0;
      rows.forEach(function (row) {
        var slot = row.querySelector('[data-so-ca-pc]');
        if (!slot) return;
        n++;
        var price = parseInt(row.getAttribute('data-so-ca-price'), 10) / 100;
        var sig = [code, v, basis, price].join('|');
        if (slot.__soQ !== q || slot.getAttribute('data-so-pc-sig') !== sig) {
          slot.__soQ = q;
          slot.setAttribute('data-so-pc-sig', sig);
          var m = code && q && cfg && basis >= 0 ? addonModel(q, basis, price, cfg, code) : null;
          if (!m) { slot.hidden = true; slot.textContent = ''; row.classList.remove('has-pc'); }
          else {
            // Name length tier: the container query drops " to [chip]" at a width that fits THIS name (CSS).
            slot.setAttribute('data-len', m.name.length > 8 ? 'l' : m.name.length > 7 ? 'm' : 's');
            slot.innerHTML = '<span class="so-cart-addons__pc-t">' + ico('check', 'so-cart-addons__pc-i') + '<b>' + esc(m.name) +
              '</b><span class="so-cart-addons__pc-to"> to ' + chip(m.code) + '</span> becomes free</span>';
            slot.hidden = false; row.classList.add('has-pc');
          }
        }
        if (!slot.hidden) shown++;
      });
      // "Adding either one gets you R30 off delivery" (both rows, same gain): hidden once every row names
      // what it makes free, so the list never says two different things about the same adds.
      box.classList.toggle('is-pc-all', n > 0 && shown === n);
    });
  }

  // ---- pre-order choice effects (snippets/so-preorder-cart.liquid) ----
  // Keep → the cheapest option for the whole cart (the 'all' delivery block's basis); Remove → for the in-stock
  // items (the 'shipnow' block's basis), both from this cart's own blocks. Shown only with a quote for the
  // CURRENT postcode and both blocks present (a mixed cart); else both are empty and hidden.
  function fillEffects() {
    var els = document.querySelectorAll('[data-so-pc-effect]');
    if (!els.length) return;
    var code = current(), q = curQuote(), cfg = cfgOnce();
    els.forEach(function (el) {
      var scope = el.closest('cart-drawer') || el.closest('.shopify-section') || document;
      var all = scope.querySelector('[data-so-cart-delivery][data-so-cd-variant="all"]');
      var now = scope.querySelector('[data-so-cart-delivery][data-so-cd-variant="shipnow"]');
      var blk = el.getAttribute('data-so-pc-effect') === 'shipnow' ? now : all;
      var basis = blk ? basisOf(blk) : null;
      var sig = [code, all && now ? 'both' : '-', basis].join('|');
      if (el.__soQ === q && el.getAttribute('data-so-pc-sig') === sig) return;
      el.__soQ = q;
      el.setAttribute('data-so-pc-sig', sig);
      var m = code && q && cfg && all && now && basis != null ? effectModel(summarise(q, basis, cfg.ladder), cfg) : null;
      if (!m) { el.hidden = true; el.textContent = ''; el.classList.remove('is-free'); return; }
      el.textContent = m.text;
      el.classList.toggle('is-free', m.free);
      el.hidden = false;
    });
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('so-preorder-cart__radio')) {
      fillAddons();
      Promise.resolve().then(renderPdp);   // after so-cart-delivery.js swaps the visible block: the card follows it
      // The swap is a `hidden` toggle (an attribute, which the childList observer never sees), done in a listener that may
      // run before or after this one: re-check after the other change listeners (microtask) and once more before paint.
      var follow = function () { if (slotBlocksChanged()) { renderSlot(); renderBar(); } };
      Promise.resolve().then(follow);
      if (window.requestAnimationFrame) requestAnimationFrame(follow);
    }
  });

  // ---- empty cart cut-off card (snippets/so-cart-empty.liquid) ----
  // [data-so-empty-cutoff] (drawer and /cart, guest and signed in) is empty and hidden in Liquid. With a quote
  // for the CURRENT postcode and a Guaranteed option there, cutoffCardModel fills it (the navy card) and hides
  // the guest's Liquid line "Order before 7 AM on a weekday…" ([data-so-empty-cutoff-line]); anything else →
  // the card is emptied and hidden again and the Liquid line comes back. Called from fillAll(), so the DOM
  // observer refills a re-rendered empty cart before it paints. The minute clock: ONE timer (a timeout re-armed
  // at each next minute boundary), running only while a filled card is connected and on screen (the
  // drawer open, the page visible); fillAll() stops it once the card is removed or hidden.
  var cutTimer = null;
  function cutOnScreen(n) {
    if (!n.isConnected || n.hidden || document.visibilityState === 'hidden') return false;
    var dr = n.closest('cart-drawer');
    return !(dr && !dr.hasAttribute('open'));
  }
  function cutClock(on) {
    if (on === !!cutTimer) return;
    if (!on) { clearTimeout(cutTimer); cutTimer = null; return; }
    // Self-realigning: each tick re-arms at the next minute boundary (fillCutoff → cutClock), so throttled or
    // late timers never drift the displayed minute; a card that is no longer live simply isn't re-armed.
    cutTimer = setTimeout(function () { cutTimer = null; fillCutoff(); }, 60000 - Date.now() % 60000 + 50);
  }
  function cutHtml(m) {
    var sub = m.parts.map(function (x) { return x.chip ? chip(m.code) : x.b ? '<b>' + esc(x.t) + '</b>' : esc(x.t); }).join('');
    var pk = m.pickup;
    return '<p class="so-ecut__top" aria-live="off">' + ico('clock', 'so-ecut__clk') + '<span>' + esc(m.top) + ' · delivering to</span> ' + chip(m.code) + '</p>' +
      '<p class="so-ecut__big" aria-live="off">' + esc(m.big) + (m.small ? ' <small>' + esc(m.small) + '</small>' : '') + '</p>' +
      '<p class="so-ecut__cs">' + sub + '</p>' +
      (m.bar ? '<span class="so-ecut__rail" aria-hidden="true"><i style="width:' + Math.round(m.bar.frac * 1000) / 10 + '%"></i></span>' +
        '<span class="so-ecut__rl" aria-hidden="true"><span>' + esc(m.bar.from) + '</span><span>' + esc(m.bar.to) + '</span></span>' : '') +
      '<p class="so-ecut__alt">' + ico(pk.icon, 'so-ecut__pi') + '<span class="so-ecut__an">' + esc(pk.name) + ' to ' + chip(pk.code) + '</span>' +
      '<span class="so-ecut__ap">' + (pk.from ? 'from ' : '') + '<b>' + esc(pk.price) + '</b>' + (pk.freeFrom ? ' · ' + esc(pk.freeFrom) : '') + '</span></p>';
  }
  function fillCutoff() {
    var nodes = document.querySelectorAll('[data-so-empty-cutoff]'), live = false;
    if (nodes.length) {
      var code = current(), q = curQuote(), cfg = cfgOnce();
      var m = code && q && cfg ? cutoffCardModel(summarise(q, 0, cfg.ladder), cfg, Date.now(), code) : null;
      var key = m ? [code, m.top, m.big, m.text, m.pickup.text, m.bar ? m.bar.frac : '-'].join('|') : '';
      nodes.forEach(function (n) {
        var scope = n.closest('[data-so-cart-empty]') || n.parentNode, line = scope && scope.querySelector('[data-so-empty-cutoff-line]');
        if (line && line.hidden !== !!m) line.hidden = !!m;
        if (n.getAttribute('data-so-pc-sig') !== key) {
          n.setAttribute('data-so-pc-sig', key);
          if (!m) { n.hidden = true; n.textContent = ''; n.removeAttribute('role'); n.removeAttribute('aria-label'); n.className = ''; }
          else {
            n.className = 'so-ecut' + (m.mode === 'countdown' ? ' is-countdown' : ' is-next');
            n.setAttribute('role', 'group');
            n.setAttribute('aria-label', m.aria);
            n.innerHTML = cutHtml(m);
            n.hidden = false;
          }
        }
        if (m && cutOnScreen(n)) live = true;
      });
    }
    cutClock(live);
  }
  document.addEventListener('visibilitychange', fillCutoff);

  // ---- the Liquid row's accessible name (Task 7 L1) ----
  // so-cart-delivery-block.liquid ends the row's aria-label with ". How delivery is priced" — true without this
  // script (the old modal). Once the click listener below takes the openers over (config present), the row opens
  // the delivery or postcode sheet instead: say so. Idempotent; fillAll() re-applies it to re-rendered rows.
  function rowLabels() {
    if (!cfgOnce()) return;
    // The Liquid "See delivery prices for your postcode" button is rendered [hidden] (it does nothing without this
    // script and the config); shown here once we take the openers over. Also after restore()/re-renders.
    document.querySelectorAll('[data-so-cart-delivery] [data-so-cd-area] .so-cart-delivery__pc[hidden]').forEach(function (b) { b.hidden = false; });
    document.querySelectorAll('[data-so-cart-delivery] .so-cart-delivery__row[data-so-cd-open][aria-label]').forEach(function (b) {
      var a = b.getAttribute('aria-label'), n = a.replace(/\. How delivery is priced$/, '. See delivery options');
      if (n !== a) b.setAttribute('aria-label', n);
    });
  }

  // ---- the old cart openers (Ruling 13) ----
  // The Liquid row (info), "See delivery prices for your postcode" and the failed/empty "Change" all carry
  // data-so-cd-open, which so-cart-delivery.js turns into the old "How delivery is priced" modal. Taken over
  // here (document capture, before that bubble listener): postcode known → the delivery sheet for THIS block's
  // basis ("Change" → the postcode sheet); no postcode → the postcode sheet, which then prices this block's
  // basis. Without this script or without the page config the old modal still opens (the fallback).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-so-cd-open]');
    var block = btn && btn.closest('[data-so-cart-delivery]');
    if (!block || !cfgOnce()) return;
    e.preventDefault();
    e.stopPropagation();
    var b = basisOf(block);
    window.soDelivery.open(current() && !btn.hasAttribute('data-so-cd-change') ? 'delivery' : 'postcode',
      { basis: b == null ? undefined : b, preorder: preorderKept(block), returnFocus: cartFocus(block), origin: 'cart' });
  }, true);

  // Where focus goes when a sheet opened from the cart closes. Resolved at close time, because by then the
  // block may be re-rendered or refilled (a postcode set from the sheet swaps the Liquid row for the footer
  // row): the visible block of the same variant → its footer row, else its Liquid row, else the
  // "See delivery prices for your postcode" button.
  function cartFocus(block) {
    var v = block.getAttribute('data-so-cd-variant') || 'all';
    return function () {
      var b = block.isConnected && !block.hidden ? block : null;
      if (!b) document.querySelectorAll('[data-so-cart-delivery][data-so-cd-variant="' + v + '"]').forEach(function (x) { if (!b && !x.hidden) b = x; });
      if (!b) return null;
      var row = b.querySelector('.so-cart-delivery__row');
      return b.querySelector('[data-so-cd-foot]') || (row && !row.hidden ? row : null) || b.querySelector('.so-cart-delivery__pc');
    };
  }

  // The footer row opens the delivery sheet for ITS block's basis: a mixed pre-order cart has an 'all' and a
  // 'shipnow' block (so-cart-delivery.js shows the one matching the Keep/Remove radio), so the sheet always
  // prices the amount the visible row was worked out on — never the sheet's /cart.js default.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-so-cd-foot]');
    if (!btn) return;
    var block = btn.closest('[data-so-cart-delivery]'), b = block ? basisOf(block) : null;
    e.preventDefault();
    window.soDelivery.open('delivery', { basis: b == null ? undefined : b, preorder: block ? preorderKept(block) : false,
                                         returnFocus: block ? cartFocus(block) : btn, origin: 'cart' });
  });

  // One-time pop-over (frame 4): the first time a cart is open with no postcode, above the visible delivery
  // row. Shown once per device: soPostcodeInviteSeen is written when it first shows (and by either button),
  // so it never nags again; within this page it is re-inserted after a cart re-render until dismissed or
  // until the drawer closes. Absolutely positioned: no height is added to the cart.
  var INVITE = 'soPostcodeInviteSeen', inviteState = null;   // null → not yet; 'on' → showing; 'done'
  function inviteSeen() { try { return !!localStorage.getItem(INVITE); } catch (e) { return true; } }
  function markInvite() { try { localStorage.setItem(INVITE, '1'); } catch (e) { /* blocked: this page only */ } }
  function openBlock() {
    var bs = document.querySelectorAll('[data-so-cart-delivery]');
    for (var i = 0; i < bs.length; i++) {
      var b = bs[i], dr = b.closest('cart-drawer');
      if (b.hidden || (dr && !dr.hasAttribute('open')) || !b.getClientRects().length) continue;
      return b;
    }
    return null;
  }
  // Per DOM mutation (fillAll): while the pop-over is showing and still in the page, no layout reads — its
  // position is re-checked only when a cart re-render dropped it, the postcode got set, or the drawer opened/closed
  // (the drawer observer calls invite() directly). Before it has ever shown, invite() decides (cheap while the
  // drawer is closed: it returns before any getClientRects()).
  function inviteCheck() {
    if (inviteState === 'done') return;
    if (inviteState === 'on' && !current() && document.querySelector('[data-so-pc-invite]')) return;
    invite();
  }
  function dropInvite() { document.querySelectorAll('[data-so-pc-invite]').forEach(function (n) { n.remove(); }); }
  // An unanswered pre-order choice (so-preorder-cart radios, none checked) in the same cart as block `b`.
  function preorderChoicePending(b) {
    var scope = b.closest('cart-drawer') || b.closest('form, main, section') || document;
    var box = scope.querySelector('so-preorder-cart');
    if (!box || !box.getClientRects().length) return false;
    var rs = Array.prototype.filter.call(box.querySelectorAll('input.so-preorder-cart__radio'), function (r) { return !!r.getClientRects().length; });
    if (rs.length) { for (var i = 0; i < rs.length; i++) if (rs[i].checked) return false; return true; }
    var tick = box.querySelector('input[type="checkbox"]');     // an all-pre-order cart: one "I understand" tick
    return !!(tick && tick.getClientRects().length && !tick.checked);
  }
  // A tap anywhere outside the pop-over closes it for good (it's a hint — it must never sit on a control).
  document.addEventListener('pointerdown', function (e) {
    if (inviteState !== 'on') return;
    var n = document.querySelector('[data-so-pc-invite]');
    if (!n || n.contains(e.target)) return;
    markInvite(); inviteState = 'done'; dropInvite();
  }, true);
  function invite() {
    if (inviteState === 'done') return;                  // every path into 'done' already removed the pop-over
    if (current()) { if (inviteState === 'on') { inviteState = 'done'; dropInvite(); } return; }
    var b = openBlock();
    if (!b) { if (inviteState === 'on') { inviteState = 'done'; dropInvite(); } return; }   // the cart closed
    // The pop-over floats above the delivery row — right over the pre-order choice. While that choice is still
    // open (checkout waits on it), stay away: not shown, not counted as seen, so a later visit can show it.
    if (preorderChoicePending(b)) { if (inviteState === 'on') { inviteState = null; dropInvite(); } return; }
    if (inviteState === null) { if (inviteSeen()) { inviteState = 'done'; return; } inviteState = 'on'; markInvite(); }
    var have = document.querySelector('[data-so-pc-invite]');
    if (have && b.contains(have)) return;
    if (have) have.remove();
    var n = document.createElement('div');
    n.className = 'so-pc-invite';
    n.setAttribute('data-so-pc-invite', '');
    n.setAttribute('role', 'region');                 // not a dialog: no focus move, no Escape (it is a hint)
    n.setAttribute('aria-labelledby', 'so-pc-invite-t');
    n.innerHTML = '<p class="so-pc-invite__t" id="so-pc-invite-t">Want your delivery price now?</p>' +
      '<p class="so-pc-invite__p">Add your postcode and the cart shows the exact price and date for every option, before checkout.</p>' +
      '<div class="so-pc-invite__row"><button type="button" class="so-pc-invite__btn" data-so-pc-invite-add>Add postcode</button>' +
      '<button type="button" class="so-pc-invite__btn so-pc-invite__btn--ghost" data-so-pc-invite-no>Not now</button></div>';
    b.insertBefore(n, b.firstChild);
    n.addEventListener('click', function (e) {
      var add = e.target.closest('[data-so-pc-invite-add]'), no = e.target.closest('[data-so-pc-invite-no]');
      if (!add && !no) return;
      e.preventDefault();
      markInvite(); inviteState = 'done'; dropInvite();
      var back = cartFocus(b);
      if (add) { var bb = basisOf(b); window.soDelivery.open('postcode', { basis: bb == null ? undefined : bb, returnFocus: back, origin: 'invite' }); }
      else { var t = back(); if (t) t.focus({ preventScroll: true }); }
    });
  }

  // A typed postcode (every surface's postcode form): no label, no point — the postcode quote.
  function setPostcode(code) { return setPlace({ code: code, label: null, src: 'typed', pt: null }); }
  function setPlace(place) {
    writeLS(KEY, placeEntry(place, Date.now()));
    failedFor = null;
    var code = place.code;
    document.querySelectorAll('[data-so-cart-delivery]').forEach(function (b) { b.removeAttribute('data-so-pc-done'); });
    var p = fetchQuote(code).then(function (q) { fillAll(); emit(); return q; });
    fillAll();                  // pending for the new code NOW: the old postcode's row must not stay on screen
    renderBar();                // …nor the old postcode's announcement bar
    renderPdp();                // …nor its product page card figure / "with this" line
    renderSlot();               // …nor the header slot's line 2
    return p;
  }

  // Postcode section at the top of the "How delivery is priced" modal: a persistent form + live message,
  // and a results area re-rendered from the lookup state for the current postcode.
  function modalForm(code) {
    return '<section class="so-cd-pc" aria-label="Delivery to your postcode">' +
      '<form class="so-cd-pc__form" data-so-pc-form novalidate><label class="so-cd-pc__label" for="so-cd-pc-input">Your postcode</label>' +
      '<div class="so-cd-pc__row"><input id="so-cd-pc-input" class="so-cd-pc__input" name="postcode" inputmode="numeric" pattern="[0-9]{4}" maxlength="4" autocomplete="postal-code" value="' + (code || '') + '">' +
      '<button type="submit" class="so-cd-pc__go">Show prices</button></div>' +
      '<p class="so-cd-pc__msg" aria-live="polite"></p></form><div class="so-cd-pc__result"></div></section>';
  }
  // What the results area shows for the current postcode: the table only for a real quote for THIS code.
  function modalState(block) {
    var code = current(), cfg = ladderOf(block), basis = basisOf(block);
    if (!code) return { state: 'none', html: '' };
    if (failed(code)) return { state: 'failed', code: code, html: '' };
    if (isPending(code)) return { state: 'pending', code: code, html: '' };
    var s = cfg && basis != null ? summarise(quote, basis, cfg) : null;
    if (!s) return { state: hasOptions(quote) || isUnconfirmed(quote) ? 'none' : 'empty', code: code, html: '' };
    var h = '<p class="so-cart-delivery-modal__sub">What checkout will charge at ' + code + ' for this order</p><table class="so-cart-delivery-modal__ladder so-cd-pc__table"><caption class="visually-hidden">Delivery options at ' + code + '</caption><tbody>';
    s.options.forEach(function (x) {
      var note = x.net === 0 ? '' : x.freeAt == null ? '' : ' <span class="so-cd-pc__free">free from ' + rand(x.freeAt) + '</span>';
      h += '<tr><th scope="row">' + optLabel(x) + note + '</th><td>' + (x.net < x.o.price ? '<s>' + rand(x.o.price) + '</s> ' : '') + netText(x.net) + '</td></tr>';
    });
    return { state: 'ok', code: code, html: h + '</tbody></table>' };
  }

  document.addEventListener('so:cd-modal-open', function (e) {
    var d = e.detail || {}; if (!d.modal || !d.block) return;
    var content = d.modal.querySelector('.so-modal__content');
    if (!content) return;
    // Fresh section per open; the form, input and aria-live message then persist for this open —
    // only the results area is re-rendered, so announcements land in the same live region.
    var old = content.querySelector('.so-cd-pc');
    if (old) old.remove();
    content.insertAdjacentHTML('afterbegin', modalForm(current()));
    var section = content.querySelector('.so-cd-pc');
    var form = section.querySelector('[data-so-pc-form]');
    var input = form.querySelector('input');
    var msg = form.querySelector('.so-cd-pc__msg');
    var results = section.querySelector('.so-cd-pc__result');
    function say(text) { if (msg.textContent !== text) msg.textContent = text; }

    // Re-render the results from the current lookup state. `announce` confirms a finished lookup.
    function render(announce) {
      if (!d.modal.isConnected || !section.isConnected) return;
      var st = modalState(d.block);
      results.innerHTML = st.html;
      if (st.state === 'pending') {
        say('Finding delivery options for ' + st.code + '…');
        fetchQuote(st.code).then(function () { if (current() === st.code) render(true); });
      } else if (st.state === 'failed') {
        say('We couldn’t load prices for ' + st.code + ' right now. Your options will show at checkout.');
      } else if (st.state === 'empty') {
        say('No delivery options found for ' + st.code + '.');
      } else if (st.state === 'ok') {
        say(announce ? 'Showing prices for ' + st.code + '.' : '');
      } else {
        say('');
      }
    }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var code = validPostcode(input.value);
      if (!code) { say('Enter a 4-digit postcode.'); input.focus(); return; }
      setPostcode(code).then(function () { render(true); });   // success, empty or failed: all re-render
      render(false);                                           // pending now: drop the old postcode's table
    });

    render(false);
    if (d.focus === 'postcode') input.focus({ preventScroll: true });
  });

  window.soPostcode = { get: current, set: setPostcode };

  // ---------------------------------------------------------------------------------------------
  // window.soDelivery — the one API every surface uses (announcement bar, cart, product page, …):
  //   config()   page delivery config {ladder, cutoffHour, pickupDays, holidays} or null
  //   postcode() the current postcode or null
  //   quote()    the loaded quote for the CURRENT postcode, or null (none / pending / failed)
  //   summary(b) summarise(quote, b, ladder) for the current postcode, or null
  //   open('postcode'|'delivery', {basis, returnFocus, origin})  the shared sheets; origin ('header' | 'bar' |
  //              'pdp' | 'cart' | 'addons' | 'invite' …) picks the pinned footer's next step
  //   on(fn)     fn({postcode, quote}) after the first quote load and after every postcode change
  //              resolves (quote null = failed/none). Subscribing after the first load replays the
  //              current state once. Returns an unsubscribe function.
  var CFG;
  function cfgOnce() { if (CFG === undefined) CFG = config(); return CFG; }
  function curQuote() { var c = current(); return hasQuote(c) ? quote : null; }
  function summary(basis) { var c = cfgOnce(), q = curQuote(); return c && q && basis >= 0 ? summarise(q, basis, c.ladder) : null; }

  var subs = [], firstDone = false;
  function state() { return { postcode: current(), quote: curQuote() }; }
  function emit() {
    var st = state();
    subs.slice().forEach(function (fn) { try { fn(st); } catch (e) { setTimeout(function () { throw e; }); } });
  }
  function on(fn) {
    if (typeof fn !== 'function') return function () {};
    subs.push(fn);
    if (firstDone) Promise.resolve().then(function () { if (subs.indexOf(fn) >= 0) fn(state()); });
    return function () { var i = subs.indexOf(fn); if (i >= 0) subs.splice(i, 1); };
  }
  // First load: after this script's synchronous subscribers are in; skipped if a postcode change
  // superseded it (setPostcode emits for that one).
  Promise.resolve().then(function () {
    var c = current();
    if (!c) { firstDone = true; emit(); return; }
    fetchQuote(c).then(function () { var was = firstDone; firstDone = true; if (!was && current() === c) emit(); });
  });

  // ---- the shared sheet shell ----
  var ICONS = {
    x: '<path d="M6 6l12 12M18 6L6 18"/>',
    info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/>',
    check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>',
    user: '<circle cx="12" cy="8.5" r="3.8"/><path d="M4.5 20c1.3-3.6 4.1-5.4 7.5-5.4s6.2 1.8 7.5 5.4"/>',
    box: '<rect x="4" y="3.5" width="16" height="17" rx="2"/><path d="M4 9.5h16M4 15h16M12 3.5v17"/><path d="M9.5 6.5h.01M14.5 12.3h.01"/>',
    door: '<path d="M3 10.5L12 4l9 6.5"/><path d="M5.5 9v11h13V9"/><path d="M10 20v-6h4v6"/>',
    shop: '<path d="M4 9l1.5-5h13L20 9"/><path d="M4 9c0 1.7 1.3 2.5 2.7 2.5S9.3 10.7 9.3 9c0 1.7 1.3 2.5 2.7 2.5s2.7-.8 2.7-2.5c0 1.7 1.3 2.5 2.6 2.5S20 10.7 20 9"/><path d="M5.5 11.5V20h13v-8.5M10 20v-5h4v5"/>',
    bolt: '<path d="M13 3L5 13.5h6L10 21l8-10.5h-6L13 3z"/>',
    truck: '<path d="M3 6.5h11v9H3zM14 9.5h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/>',
    lock: '<rect x="5" y="10.5" width="14" height="10" rx="2"/><path d="M8.5 10.5V7.5a3.5 3.5 0 017 0v3"/>',
    alert: '<circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5M12 16.2h.01"/>',
    clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
    chev: '<path d="M9.5 6l6 6-6 6"/>',
    pin: '<path d="M12 21s-6.5-6.1-6.5-11.2a6.5 6.5 0 0113 0C18.5 14.9 12 21 12 21z"/><circle cx="12" cy="9.8" r="2.3"/>',
    back: '<path d="M19 12H5.5M11 6l-6 6 6 6"/>',
    cart: '<path d="M3 4h2.2l2.3 10.5h10.8L20.5 7H6.3"/><circle cx="9.5" cy="19" r="1.4"/><circle cx="17" cy="19" r="1.4"/>'
  };
  function ico(k, cls) { return '<svg class="' + (cls || 'so-dsheet__i') + '" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + (ICONS[k] || ICONS.door) + '</svg>'; }
  function chip(code, lg) { return '<span class="so-pc-chip' + (lg ? ' so-pc-chip--lg' : '') + '">' + esc(code) + '</span>'; }

  var sh = null, savedScroll = null, swallowEscUp = false;

  // Scroll lock as in so-cart-delivery.js: page + the drawer's own scroller stay put; the prior inline
  // styles are restored exactly (the cart drawer applies its own lock and we must not clear it).
  // The sheet node can be removed from the page by something else (a theme re-render, another script).
  // Then drop our state so nothing stays scroll-locked and Tab/Escape work page-wide again.
  function alive() {
    if (sh && !sh.root.isConnected) { unlockScroll(); sh = null; swallowEscUp = false; }
    return !!sh;
  }
  function blockOutside(e) {
    if (!alive()) return;
    var panel = sh.root.querySelector('.so-dsheet__panel');
    if (panel && panel.contains(e.target)) return;
    e.preventDefault();
  }
  function lockScroll() {
    if (savedScroll) return;
    savedScroll = { html: document.documentElement.style.overflow, body: document.body.style.overflow };
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.addEventListener('wheel', blockOutside, { passive: false, capture: true });
    document.addEventListener('touchmove', blockOutside, { passive: false, capture: true });
  }
  function unlockScroll() {
    if (!savedScroll) return;
    document.documentElement.style.overflow = savedScroll.html;
    document.body.style.overflow = savedScroll.body;
    savedScroll = null;
    document.removeEventListener('wheel', blockOutside, { capture: true });
    document.removeEventListener('touchmove', blockOutside, { capture: true });
  }

  // One shell for both sheets; a second open() re-uses it (switches the content in place).
  function openSheet(html, returnFocus) {
    if (!alive()) {
      var root = document.createElement('div');
      root.className = 'so-dsheet';
      root.setAttribute('role', 'dialog');
      root.setAttribute('aria-modal', 'true');
      root.setAttribute('aria-labelledby', 'so-dsheet-title');
      root.innerHTML = '<div class="so-dsheet__backdrop" data-so-dsheet-close></div>' +
        '<div class="so-dsheet__panel"><span class="so-dsheet__grab" aria-hidden="true"></span>' +
        '<button type="button" class="so-dsheet__x" data-so-dsheet-close aria-label="Close">' + ico('x') + '</button>' +
        '<div class="so-dsheet__content"></div>' +
        '<div class="so-dsheet__foot" data-so-dsheet-foot hidden></div>' +
        '<p class="so-dsheet__sr" role="status" aria-live="polite"></p></div>';
      root.addEventListener('click', onSheetClick);
      document.body.appendChild(root);
      sh = { root: root, content: root.querySelector('.so-dsheet__content'), live: root.querySelector('[role="status"]'),
             returnFocus: returnFocus || document.activeElement, basis: null, view: null, seq: 0,
             origin: 'page', saved: false, cart: seedCart(), cartP: null };
      // Phones: swipe down to close (shared assets/so-sheet-swipe.js). Same close path as ×/backdrop/Escape.
      if (window.soSheetSwipe) window.soSheetSwipe.attach(root.querySelector('.so-dsheet__panel'), {
        handle: '.so-dsheet__grab, .so-dsheet__head', scroller: '.so-dsheet__body', backdrop: root.querySelector('.so-dsheet__backdrop'),
        onClose: function () { if (sh && sh.root === root) closeSheet(); }
      });
      lockScroll();
      void root.offsetWidth;                         // forced reflow, then slide in
      root.classList.add('is-open');
    } else if (returnFocus) sh.returnFocus = returnFocus;
    if (html != null) paint(html);
    return sh;
  }
  // Swap the content; if focus was inside the old content, keep it on the same control (data-k) or the title.
  function paint(html) {
    var a = document.activeElement, key = a && sh.content.contains(a) ? (a.getAttribute('data-k') || '#') : null;
    sh.root.classList.remove('is-typing');   // a new view never starts in search mode (the old field's blur won't fire)
    sh.content.innerHTML = html;
    if (key) {
      var back = key !== '#' && sh.content.querySelector('[data-k="' + key + '"]');
      var to = back || sh.content.querySelector('#so-dsheet-title') || sh.root.querySelector('.so-dsheet__x');
      if (to) to.focus({ preventScroll: true });
    }
    renderFoot();
  }
  function say(text) { if (sh) { sh.live.textContent = ''; if (text) setTimeout(function () { if (sh) sh.live.textContent = text; }, 30); } }
  function closeSheet(noFocus) {
    if (!sh) return;
    var s = sh; sh = null;
    if (s.saved && CART_ORIGINS.indexOf(s.origin) < 0) slotGlow();   // the customer sees where the postcode now lives
    s.seq++;
    var t = s.root.querySelector('#so-dsheet-title'); if (t) t.removeAttribute('id');
    s.root.classList.remove('is-open');
    s.root.classList.add('is-closing');
    s.root.setAttribute('aria-hidden', 'true');
    setTimeout(function () { s.root.remove(); }, 260);
    unlockScroll();
    if (noFocus) return;                                   // "View cart": the drawer takes focus
    var back = typeof s.returnFocus === 'function' ? s.returnFocus() : s.returnFocus;   // function = resolve now
    if (back && back.isConnected && typeof back.focus === 'function' && back !== document.body) back.focus({ preventScroll: true });
  }
  function focusables() {
    return Array.prototype.filter.call(sh.root.querySelectorAll('button, input, a[href], [tabindex]:not([tabindex="-1"])'),
      function (el) { return !el.disabled && el.offsetParent !== null; });
  }
  // Window capture phase: runs before any document listener (the cart drawer, so-cart-delivery,
  // so-cart-addons), so Escape closes only this sheet. cart-drawer.js closes the drawer on Escape
  // KEYUP, so the keyup that follows is swallowed too (as in so-cart-addons.js).
  window.addEventListener('keydown', function (e) {
    if (!alive()) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault(); e.stopPropagation(); swallowEscUp = true;
      var cb = sh.content.querySelector('[role="combobox"][aria-expanded="true"]');
      if (cb && typeof cb.soCollapse === 'function') { cb.soCollapse(); return; }   // Escape closes the suggestion list only
      closeSheet(); return;
    }
    if (e.key !== 'Tab') return;
    e.stopPropagation();
    var f = focusables();
    e.preventDefault();
    if (!f.length) return;
    var i = f.indexOf(document.activeElement);
    var to = e.shiftKey ? (i <= 0 ? f[f.length - 1] : f[i - 1]) : (i === -1 || i === f.length - 1 ? f[0] : f[i + 1]);
    to.focus();
  }, true);
  window.addEventListener('keyup', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && swallowEscUp) { e.preventDefault(); e.stopPropagation(); swallowEscUp = false; }
  }, true);

  function onSheetClick(e) {
    var t = e.target.closest ? e.target : e.target.parentElement;
    if (!t || !sh) return;
    if (t.closest('[data-so-dsheet-close]')) { e.preventDefault(); closeSheet(); return; }
    if (t.closest('[data-so-dsheet-cart]')) { e.preventDefault(); viewCart(); return; }
    if (t.closest('[data-so-dsheet-change]')) { e.preventDefault(); showPostcode(); return; }
    if (t.closest('[data-so-dsheet-retry]')) {
      e.preventDefault();
      var c = current(); if (!c) { showPostcode(); return; }
      if (sh.basis < 0) { sh.basis = null; sh.cartP = null; }   // the /cart.js read failed: read it again (the footer keeps its seed)
      setPlace(currentPlace()); showDelivery();    // failedFor cleared → pending view, then re-render on resolve (same place, same key)
    }
  }

  function head(title, sub, change, subRole) {
    return '<div class="so-dsheet__head"><div class="so-dsheet__t"><h2 id="so-dsheet-title" class="so-dsheet__title" tabindex="-1">' + title + '</h2>' +
      (sub ? '<p class="so-dsheet__sub">' + sub + '</p>' : '') + '</div>' +
      (change ? '<button type="button" class="so-dsheet__chg" data-so-dsheet-change data-k="chg" aria-label="Change postcode">Change</button>' : '') + '</div>';
  }
  function signedIn() { return !!document.querySelector('script[data-so-customer]'); }
  // Sign in from the postcode sheet: new customer accounts only honour `return_to` (the old /account/login drops
  // any return URL and lands on the profile). The marker `so_pc=1` brings the customer back to this page and
  // re-opens delivery there (boot → signInReturn).
  var SIGNIN_MARK = 'so_pc';
  function signInUrl(path, search) {
    var q = String(search || '').replace(/^\?/, '').split('&').filter(function (kv) { return kv && kv.split('=')[0] !== SIGNIN_MARK; });
    q.push(SIGNIN_MARK + '=1');
    var safe = '/' + String(path || '/').replace(/^[\/\\]+/, '');   // always a same-site path, never //host (open redirect)
    return '/customer_authentication/login?return_to=' + encodeURIComponent(safe + '?' + q.join('&'));
  }
  // Back from sign-in: drop the marker from the address bar; signed in with an account postcode → that address is
  // the reason they signed in, so it replaces this device's place and delivery opens; otherwise the postcode sheet.
  function signInReturn() {
    var m = new RegExp('([?&])' + SIGNIN_MARK + '=1(&|$)');
    if (!m.test(location.search)) return;
    try {
      var rest = location.search.replace(m, function (_, a, b) { return b ? a : ''; }).replace(/\?$/, '');
      history.replaceState(history.state, '', location.pathname + rest + location.hash);
    } catch (e) { /* history blocked: the marker stays, harmless */ }
    var acc = signedIn() && accountPostcode();
    if (acc) { setPlace(accountPlace()); open('delivery', {}); }
    else open('postcode', {});
  }

  // ---- postcode sheet ----
  // Task 18: ONE field for a postcode, suburb or town (replaces the four digit boxes — see task-18-report.md); letters
  // open an accessible combobox of suggestions from so-mail /delivery/places (200 ms debounce, 2+ characters);
  // picking one saves that postcode labelled with the suburb. "Use my location" (hidden without
  // navigator.geolocation) → /delivery?lat&lng → the nearest postcode, labelled "Near …", its quote keyed on the
  // rounded point.
  // Task 20 (Charl's iPhone): "Use my location" is the primary button at the top, then "or", then the field
  // (postcodeParts). No "Show options" button and no ABC/123 toggle: a suggestion pick (tap / Enter), a value that
  // becomes exactly 4 digits (typed, pasted or the iOS postcode chip — the `input` event) or Enter on 4 digits
  // proceeds on its own (proceedAction). Touch devices focus the title on open, not the field (focusTarget).
  var sugCache = {};
  function pointerFlags() {
    var mq = function (q) { try { return !!(window.matchMedia && window.matchMedia(q).matches); } catch (e) { return false; } };
    return { coarse: mq('(pointer: coarse)'), hoverNone: mq('(hover: none)') };
  }
  // "Your addresses" (signed in): one-tap rows — suburb + postcode, "Default", and the current place marked.
  function addrList(list, was) {
    if (!list.length) return '';
    return '<section class="so-dsheet__addr" aria-labelledby="so-dsheet-addr-h"><h3 id="so-dsheet-addr-h" class="so-dsheet__addr-h">Your addresses</h3><ul>' +
      list.map(function (a, i) {
        var on = !!(was && was.src === 'account' && was.code === a.code);
        return '<li><button type="button" class="so-dsheet__addr-b" data-so-dsheet-addr="' + i + '" data-k="addr-' + i + '"' + (on ? ' aria-current="true"' : '') + '>' +
          ico('user', 'so-dsheet__i so-dsheet__addr-i') + '<span class="so-dsheet__addr-t">' + (a.area ? esc(a.area) + ' · ' : '') + chip(a.code) + '</span>' +
          (on ? '<span class="so-dsheet__addr-m">Current</span>' : a.default ? '<span class="so-dsheet__addr-m">Default</span>' : '') + '</button></li>';
      }).join('') + '</ul></section>';
  }
  function showPostcode() {
    sh.view = 'postcode'; sh.seq++;
    var geo = !!(navigator.geolocation && typeof navigator.geolocation.getCurrentPosition === 'function');
    // Task 21: with a place already set, say what it is (currentLine) and, if it came from the location, the button
    // becomes the secondary "Update my location" (locateButton). The field stays empty, to choose somewhere else.
    var was = currentPlace(), cur = currentLine(was), lb = locateButton(was);
    if (cur && was.src === 'account' && signedIn() && savedAddresses().some(function (a) { return a.code === was.code; })) cur = null;   // the list marks it "Current"
    var parts = {
      locate: '<button type="button" class="so-dsheet__btn so-dsheet__loc' + (lb.secondary ? ' so-dsheet__btn--ghost' : '') + '" data-so-dsheet-locate data-k="loc">' + ico('pin') + '<span>' + lb.text + '</span></button>',
      or: '<div class="so-dsheet__or"><span>or</span></div>',
      field: '<label class="so-dsheet__flbl" for="so-dsheet-pc">Search suburb, town or postcode</label>' +
        '<div class="so-dsheet__field">' + ico('pin', 'so-dsheet__i so-dsheet__fi') +
        '<input id="so-dsheet-pc" class="so-dsheet__input" name="postcode" type="text" inputmode="text" autocomplete="postal-code" autocapitalize="words" autocorrect="off" spellcheck="false" enterkeyhint="search"' +
        ' role="combobox" aria-autocomplete="list" aria-expanded="false" aria-controls="so-dsheet-sug" aria-describedby="so-dsheet-pc-hint so-dsheet-pc-err" placeholder="' + PC_PLACEHOLDER + '">' +
        '<span class="so-dsheet__spin" aria-hidden="true"></span></div>' +
        '<ul id="so-dsheet-sug" class="so-dsheet__sug" role="listbox" aria-label="Places" hidden></ul>' +
        '<p id="so-dsheet-pc-hint" class="so-dsheet__hint">Your options open as soon as you pick a suburb or finish a 4-digit postcode.</p>' +
        '<p id="so-dsheet-pc-err" class="so-dsheet__err" aria-live="polite"></p>'
    };
    paint(head('Where should we deliver?', 'Your postcode or suburb shows every option’s price and arrival date. We keep it on this device.') +
      '<div class="so-dsheet__body">' +
      (cur ? '<p class="so-dsheet__cur">' + ico('pin', 'so-dsheet__i so-dsheet__cur-i') + '<span class="so-dsheet__cur-t">' +
        (cur.name ? '<b>' + esc(cur.name) + '</b> · ' : '') + chip(cur.code) + (cur.note ? ' · ' + esc(cur.note) : '') + '</span></p>' : '') +
      (signedIn() ? addrList(savedAddresses(), was) : '') +
      '<form class="so-dsheet__form" novalidate>' +
      postcodeParts(geo).map(function (p) { return parts[p]; }).join('') + '</form>' +
      (signedIn() ? '' : '<div class="so-dsheet__acct"><span class="so-dsheet__acct-i">' + ico('user') + '</span><p class="so-dsheet__acct-t"><b>Have an account?</b> Sign in and we’ll use your delivery address.</p><a class="so-dsheet__lnk" href="' + esc(signInUrl(location.pathname, location.search)) + '">Sign in</a></div>') +
      '<p class="so-dsheet__priv">' + ico('lock') + '<span>Used only to show delivery options. Checkout asks for your full address.</span></p></div>');
    var form = sh.content.querySelector('form'), input = form.querySelector('input'), field = form.querySelector('.so-dsheet__field');
    var err = form.querySelector('.so-dsheet__err'), list = form.querySelector('.so-dsheet__sug'), loc = form.querySelector('[data-so-dsheet-locate]');
    var signIn = sh.content.querySelector('.so-dsheet__lnk');
    if (signIn) signIn.addEventListener('click', function () { var t = TR(); if (t) t.send('signin_tap', {}); });
    var busy = false, going = null, gseq = 0, sugs = [], active = -1, timer = null, qseq = 0, view = sh.seq;
    var stok = sessionToken();   // Task 31: this opening's Google session token (a new one after each pick)
    function rotate() { stok = sessionToken(); sugCache = {}; }   // the old token's cached lists (and Google rows) go with it
    var touch = focusTarget(pointerFlags()) === 'title';
    function mine() { return sh && sh.seq === view; }
    // Phones, while the field has focus: compact search mode (.is-typing) — the sheet moves to the top of the screen
    // and drops everything but its title, the field and the suggestions, so iOS has nothing to push up when the
    // keyboard and the suggestion list open. Leaves on blur (a suggestion tap keeps focus: list mousedown).
    if (touch) {
      input.addEventListener('focus', function () { if (mine()) sh.root.classList.add('is-typing'); });
      input.addEventListener('blur', function () {
        setTimeout(function () { if (sh && sh.root && document.activeElement !== input) sh.root.classList.remove('is-typing'); }, 120);
      });
    }
    function kind() { return inputKind(input.value); }
    function sync() { if (loc) loc.disabled = busy; }
    // The lookup's busy state lives in the field (a spinner where the old toggle sat); the words go to the live err line.
    function setBusy(on) {
      field.classList.toggle('is-busy', on);
      if (on) input.setAttribute('aria-busy', 'true'); else input.removeAttribute('aria-busy');
    }
    function setActive(i) {
      active = i;
      Array.prototype.forEach.call(list.querySelectorAll('[data-i]'), function (li, j) { li.setAttribute('aria-selected', j === i ? 'true' : 'false'); li.classList.toggle('is-active', j === i); });
      if (i >= 0 && list.children[i]) { input.setAttribute('aria-activedescendant', list.children[i].id); list.children[i].scrollIntoView({ block: 'nearest' }); }
      else input.removeAttribute('aria-activedescendant');
    }
    function collapse() { list.hidden = true; input.setAttribute('aria-expanded', 'false'); setActive(-1); }
    input.soCollapse = collapse;
    function render(items, google) {
      sugs = items; active = -1;
      list.innerHTML = items.map(function (x, i) {
        var r = sugRow(x);
        return '<li id="so-dsheet-sug-' + i + '" role="option" aria-selected="false" class="so-dsheet__sopt" data-i="' + i + '">' +
          '<span class="so-dsheet__sl">' + esc(r.label) + '</span>' + (r.chip ? chip(r.chip) : '<span class="so-dsheet__smore" aria-hidden="true">›</span>') + '</li>';
      }).join('') +
        // Google's attribution for text-only autocomplete: a last, non-interactive line.
        (google && items.length ? '<li class="so-dsheet__sattr" role="presentation" aria-hidden="true">Powered by Google</li>' : '');
      var open = items.length > 0 && document.activeElement === input;
      list.hidden = !open; input.setAttribute('aria-expanded', open ? 'true' : 'false'); input.removeAttribute('aria-activedescendant');
      sync();
    }
    function search() {
      var q = kind().query, n = ++qseq;
      if (!q) { render([]); return; }
      var ck = stok + '|' + q.toLowerCase(), hit = sugCache[ck];   // per session token: Google rows never outlive it
      var p = hit ? Promise.resolve(hit) : fetchTimeout(placesUrl(ENDPOINT, q, stok), { credentials: 'omit' }, 5000)
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (d) { var m = suggestionModel(d); sugCache[ck] = m; return m; });
      p.then(function (m) {
        if (!mine() || n !== qseq) return;
        var items = m.items;
        render(items, m.google);
        err.textContent = items.length ? '' : 'No place found. Try your 4-digit postcode.';
        if (items.length) say(items.length + ' place' + (items.length === 1 ? '' : 's') + ' found. Use the arrow keys to choose.');
        else { var t = TR(); if (t) t.send('search_no_hits', { queryLength: q.length }); }
      }, function () {
        if (!mine() || n !== qseq) return;
        render([]); err.textContent = 'Suburb search isn’t available right now. Type your 4-digit postcode.';
      });
    }
    // Save a place and show its options (a suburb pick, a 4-digit postcode, or a location); a newer go() wins.
    function go(place, shown) {
      var seq = sh.seq, code = place.code, g = ++gseq;
      busy = true; going = code; setBusy(true); collapse(); sync();
      clearTimeout(timer); qseq++;
      if (shown) input.value = shown;
      err.textContent = sheetMsg('loading', code);
      setPlace(place).then(function (q) {
        if (!sh || sh.seq !== seq || g !== gseq) return;
        busy = false; going = null; setBusy(false); sync();
        var c = cfgOnce();
        if (q && (isUnconfirmed(q) || (c ? summarise(q, 0, c.ladder) : hasOptions(q)))) {
          sh.saved = true;
          var t = TR(); if (t) { t.send('postcode_set', { pc: code, src: place.src }); t.claritySet(true, place.src); t.clarityEvent('so_postcode_set'); }
          showDelivery(true);
          return;
        }
        err.textContent = sheetMsg(q ? 'empty' : 'failed', code);
      });
    }
    function pick(i) {
      var x = sugs[i]; if (!x) return;
      var t = TR(); if (t) t.send('suggestion_pick', pickEvent(x));
      if (x.placeId) { pickGoogle(x); return; }
      rotate();
      go(placeFromSuggestion(x), x.name + ' · ' + x.postcode);
    }
    // Task 31: a Google row → busy → so-mail /delivery/place (Place Details, this session's token) → its postcode →
    // go() exactly like an own pick. No postcode (or a failure) → the field asks for the 4 digits for that place;
    // nothing is focused (touch rule) and search mode stays as it is.
    function pickGoogle(x) {
      if (busy) return;
      var tok = stok, g = ++gseq;
      rotate();                                                // the session ends with this Place Details call
      busy = true; setBusy(true); collapse(); sync();
      clearTimeout(timer); qseq++;
      input.value = x.name;
      err.textContent = 'Finding the postcode for ' + x.name + '…';
      fetchTimeout(placeUrl(ENDPOINT, x.placeId, tok), { credentials: 'omit' }, 5000)
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; })
        .then(function (d) {
          if (!mine() || g !== gseq) return;
          busy = false; setBusy(false); sync();
          var r = placeResult(d);
          if (r) {
            var pl = { code: r.code, label: r.label, src: 'search', pt: null };
            if (r.approx) pl.approx = true;
            go(pl, (r.approx ? 'Near ' : '') + (r.label || x.name) + ' · ' + r.code);
            return;
          }
          input.value = '';
          input.setAttribute('placeholder', '4-digit postcode');   // the full sentence (long names) goes on the line below
          err.textContent = needPostcode(x.name) + '.';
        });
    }
    function typed(code) { go({ code: code, label: null, src: 'typed', pt: null }); }
    var addrs = signedIn() ? savedAddresses() : [];
    sh.content.querySelectorAll('[data-so-dsheet-addr]').forEach(function (b) {
      b.addEventListener('click', function () {
        var a = addrs[+b.getAttribute('data-so-dsheet-addr')];
        if (a && !busy) {
          var t = TR(); if (t) t.send('account_address_pick', { pc: a.code });
          go({ code: a.code, label: a.area, src: 'account', pt: null }, (a.area ? a.area + ' · ' : '') + a.code);
        }
      });
    });
    // Enter (keydown, or a form submit where a browser sends one).
    function enter() {
      var a = proceedAction(input.value, 'enter', sugs.length);
      if (a.act === 'code') { if (!(busy && going === a.code)) typed(a.code); return; }
      if (busy) return;
      if (a.act === 'pick') { pick(active >= 0 ? active : 0); return; }
      err.textContent = a.text;
    }
    input.addEventListener('input', function () {
      err.textContent = '';
      // Task 31: after a Google pick with no postcode the placeholder read "4-digit postcode"; typing restores it.
      if (input.getAttribute('placeholder') !== PC_PLACEHOLDER) input.setAttribute('placeholder', PC_PLACEHOLDER);
      var k = kind();
      if (k.kind === 'digits' && k.digits !== input.value.replace(/\s+/g, '')) input.value = k.digits;   // 4 digits max, as before
      clearTimeout(timer);
      var a = proceedAction(input.value, 'input', 0);
      if (a) { qseq++; render([]); if (!(busy && going === a.code)) typed(a.code); return; }   // 4 digits: on its own
      k = kind();
      if (k.kind !== 'text') { qseq++; render([]); return; }
      sync();
      if (k.query) timer = setTimeout(search, 200); else { qseq++; render([]); }
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); enter(); return; }
      if (list.hidden || !sugs.length) return;
      if (e.key === 'ArrowDown' || e.key === 'Down') { e.preventDefault(); setActive(active < sugs.length - 1 ? active + 1 : 0); }
      else if (e.key === 'ArrowUp' || e.key === 'Up') { e.preventDefault(); setActive(active > 0 ? active - 1 : sugs.length - 1); }
    });
    input.addEventListener('blur', function () { setTimeout(function () { if (mine() && document.activeElement !== input) collapse(); }, 150); });
    input.addEventListener('focus', function () { if (sugs.length && kind().kind === 'text') { list.hidden = false; input.setAttribute('aria-expanded', 'true'); } });
    // mousedown keeps focus in the input (no blur-collapse before the click lands).
    list.addEventListener('mousedown', function (e) { e.preventDefault(); });
    list.addEventListener('click', function (e) { var li = e.target.closest('[data-i]'); if (li) pick(+li.getAttribute('data-i')); });
    form.addEventListener('submit', function (ev) { ev.preventDefault(); enter(); });
    // After a location failure: the field on a fine pointer (as before); on touch, focus stays on the button (a
    // programmatic focus would open the keyboard over the message) — the message is in the live err line.
    function toField() { if (!touch) input.focus({ preventScroll: true }); }
    if (loc) loc.addEventListener('click', function () {
      if (busy) return;
      if (loc.hasAttribute('data-blocked')) { err.textContent = geoMessage(1); toField(); return; }
      var t0 = TR(); if (t0) { t0.send('locate_tap', {}); t0.clarityEvent('so_locate_tap'); }
      busy = true; collapse(); err.textContent = '';
      loc.querySelector('span').textContent = 'Finding your location…'; sync();
      var seq = sh.seq;
      function fail(msg) {
        if (!sh || sh.seq !== seq) return;
        busy = false; loc.querySelector('span').textContent = lb.text; sync();
        err.textContent = msg; toField();
      }
      navigator.geolocation.getCurrentPosition(function (pos) {
        if (!sh || sh.seq !== seq) return;
        // The EXACT point goes to so-mail once (it passes it to Bob Go and keeps a ~1 km rounding); this browser
        // keeps only pointKey() — the point rounded to 2 decimals.
        var lat = +pos.coords.latitude.toFixed(5), lng = +pos.coords.longitude.toFixed(5), pt = pointKey(lat, lng), v = quoteVersion(cfgOnce());
        fetchTimeout(locateUrl(ENDPOINT, lat, lng, v), { credentials: 'omit' }, 8000)
          .then(function (r) { if (r.status === 400) throw new Error('outside'); if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
          .then(function (data) {
            var pl = placeFromNear(data, pt);
            if (!pl) throw new Error('bad quote');
            if (!sh || sh.seq !== seq) return;
            quote = data; quoteFor = quoteKey(pl); failedFor = null;          // the quote in hand: setPlace won't refetch
            storeQuote(quoteFor, pl.code, v, data);
            busy = false; loc.querySelector('span').textContent = lb.text;
            var tl = TR(); if (tl) tl.send('locate_ok', { pc: pl.code });
            go(pl, (pl.label ? 'Near ' + pl.label + ' · ' : '') + pl.code);
          })
          .catch(function (e) {
            var tq = TR(); if (tq) tq.send('quote_fail', { code: tq.quoteFailCode(e) });
            fail(e && e.message === 'outside' ? 'We deliver in South Africa only. Type your postcode or suburb instead.'
                                              : 'We couldn’t find delivery prices for your location. Type your postcode or suburb instead.');
          });
      }, function (e) {
        var tf = TR(); if (tf) { tf.send('locate_fail', { code: tf.locateFailCode(e && e.code) }); tf.clarityEvent('so_locate_fail'); }
        fail(geoMessage(e && e.code));
        if (e && e.code === 1 && sh && sh.seq === seq) { loc.setAttribute('data-blocked', ''); loc.querySelector('span').textContent = 'Location blocked · how to allow'; }
      },
      // 20 s: laptop Wi-Fi positioning is slow.
      { enableHighAccuracy: false, timeout: 20000, maximumAge: 600000 });
    });
    // Already blocked for this site (Permissions API, where there is one): say so on the button; a tap explains how
    // to allow it instead of silently failing.
    if (loc && navigator.permissions && navigator.permissions.query) {
      navigator.permissions.query({ name: 'geolocation' }).then(function (st) {
        if (!mine() || st.state !== 'denied') return;
        loc.setAttribute('data-blocked', '');
        loc.querySelector('span').textContent = 'Location blocked · how to allow';
      }, function () { /* unsupported name: keep the plain button */ });
    }
    sync();
    if (touch) { var t = sh.content.querySelector('#so-dsheet-title'); if (t) t.focus({ preventScroll: true }); }
    else input.focus({ preventScroll: true });
    if (cur) say(cur.aria);                       // the current place, announced on open
  }

  // ---- delivery sheet ----
  // /cart.js once: {subtotal (the delivery basis), count, total} in rands, or null when it can't be read.
  // Task 28: also the freshest cart JSON we've seen this page (lastCartFull, incl. .attributes) — the
  // _so_delivery attribute writer reads it from here instead of fetching /cart.js of its own.
  function cartInfo() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (c) {
        if (c) lastCartFull = c;
        var b = c && c.items_subtotal_price / 100;
        var r = b >= 0 ? { subtotal: b, count: c.item_count >= 0 ? c.item_count : 0, total: c.total_price >= 0 ? c.total_price / 100 : b } : null;
        if (r) lastCart = { count: r.count, total: r.total };
        return r;
      })
      .catch(function () { return null; });
  }
  // The freshest cart the page knows, synchronously (the sheet footer's seed): the last /cart.js read or theme cart
  // event (count + total), unless the header count bubble now says another count (a silent add) → that count, total
  // unknown; no read yet → the bubble's count; no bubble → count unknown.
  var lastCart = null, lastCartFull = null;
  function bubbleCount() {
    var b = document.getElementById('cart-icon-bubble');
    if (!b) return null;
    var n = b.querySelector('.header__cart-count-number');
    if (n) { var v = parseInt(n.textContent, 10); return v >= 0 ? v : null; }
    return b.querySelector('.header__cart-count') ? null : 0;      // no badge = empty cart (10,000+ hides the number)
  }
  function seedCart() {
    var bc = bubbleCount();
    if (lastCart && (bc == null || bc === lastCart.count)) return { count: lastCart.count, total: lastCart.total };
    return { count: bc, total: null };
  }
  function cartBasis(p) { return (p || cartInfo()).then(function (c) { return c ? c.subtotal : -1; }); }
  function msgBody(text, retry, icon) {
    return '<div class="so-dsheet__body"><div class="so-dsheet__msg' + (retry ? ' is-err' : '') + '">' + ico(icon || 'info') + '<p>' + esc(text) + '</p></div>' +
      (retry ? '<button type="button" class="so-dsheet__btn so-dsheet__btn--ghost" data-so-dsheet-retry data-k="retry">Try again</button>' : '') + '</div>';
  }
  function skeleton() {
    var r = '<li class="so-dsheet__sk-row"><span class="so-dsheet__sk so-dsheet__sk--i"></span><span><span class="so-dsheet__sk so-dsheet__sk--l1"></span><span class="so-dsheet__sk so-dsheet__sk--l2"></span></span><span class="so-dsheet__sk so-dsheet__sk--p"></span></li>';
    return '<ul class="so-dsheet__opts" aria-hidden="true">' + r + r + r + '</ul>';
  }
  function rowHtml(r, code) {
    var price = (r.was ? '<s class="so-dsheet__was"><span class="so-dsheet__sr">was </span>' + r.was + '</s>' : '') +
      (r.from ? '<span class="so-dsheet__from">from</span>' : '') +
      '<span class="so-dsheet__now' + (r.free ? ' is-free' : '') + '">' + r.now + '</span>';
    // Information only (checkout can't be pre-selected): plain list items in one panel, no ring, no focus.
    return '<li class="so-dsheet__opt' + (r.flag ? ' is-cheapest' : '') + '">' +
      '<span class="so-dsheet__oi">' + ico(r.icon) + '</span>' +
      '<span class="so-dsheet__ob"><span class="so-dsheet__on">' + esc(r.name) +
      (r.badge ? ' <span class="so-dsheet__badge ' + (r.badge === 'Guaranteed' ? 'is-g' : 'is-e') + '">' + r.badge + '</span>' : '') + '</span>' +
      (r.flag ? '<span class="so-dsheet__flag">' + esc(r.flag) + '</span>' : '') +
      (r.sub ? '<span class="so-dsheet__os">' + esc(r.sub) + '</span>' : '') +
      (r.when ? '<span class="so-dsheet__ow">' + (r.when.lead ? r.when.lead + ' <b>' + esc(r.when.text) + '</b>' : esc(r.when.text)) + '</span>' : '') + '</span>' +
      '<span class="so-dsheet__op">' + price + '</span>' +
      // Task 22 → Task 25 trim: every pending row shows the muted "Free from R999" line; the "R800 to go" text
      // and the 4px progress bar are added ONLY on the goal row (r.goal), in bold orange.
      (r.freeFrom ? '<span class="so-dsheet__og' + (r.goal ? ' is-goal' : '') + '"><span class="so-dsheet__ogt">' + esc(r.freeFrom) +
        (r.goal ? ' · <span class="so-dsheet__tg">' + esc(r.toGo) + '</span>' : '') + '</span>' +
        (r.goal ? '<span class="so-dsheet__ogb" aria-hidden="true"><i style="width:' + Math.round(r.fraction * 1000) / 10 + '%"></i></span>' : '') + '</span>' : '') + '</li>';
  }
  function showDelivery(announce) {
    var code = current();
    if (!code) { showPostcode(); return; }
    sh.view = 'delivery';
    var tp = sheetTitle(currentPlace(), code);
    var seq = ++sh.seq, cfg = cfgOnce();
    var title = esc(tp.lead) + ' ' + chip(code, true);
    function again(a) { return function () { if (sh && sh.seq === seq) showDelivery(a); }; }
    if (sh.basis == null && cfg) {
      paint(head(title, esc(sheetMsg('loading', code)), true) + '<div class="so-dsheet__body">' + skeleton() + '</div>');
      say(sheetMsg('loading', code));
      cartBasis(readCart()).then(function (b) { if (sh && sh.seq === seq) { sh.basis = b; showDelivery(true); } });
      return;
    }
    if (!cfg) { paint(head(title, '', true) + msgBody(sheetMsg('noconfig', code))); if (announce) say(sheetMsg('noconfig', code)); return; }
    if (failed(code) || sh.basis < 0) {
      paint(head(title, '', true) + msgBody(sheetMsg('failed', code), true, 'alert'));
      say(sheetMsg('failed', code));
      return;
    }
    if (isPending(code)) {
      paint(head(title, esc(sheetMsg('loading', code)), true) + '<div class="so-dsheet__body">' + skeleton() + '</div>');
      say(sheetMsg('loading', code));
      fetchQuote(code).then(again(true));
      return;
    }
    var m = sheetModel(quote, sh.basis, cfg, Date.now(), code, { preorder: !!sh.preorder, place: currentPlace() });
    if (m.state !== 'ok') { paint(head(title, '', true) + msgBody(m.message)); say(m.message); return; }
    paint(head(title, tp.place ? '<span class="so-dsheet__subp">' + esc(subLine(tp.place, m.sub)) + '</span>' : esc(m.sub), true) + '<div class="so-dsheet__body">' +
      (m.banner ? '<div class="so-dsheet__cut">' + ico('clock') + '<div><p class="so-dsheet__cut-t">' + esc(m.banner.title) + '</p><p class="so-dsheet__cut-s">' + esc(m.banner.sub) + '</p></div></div>' : '') +
      (m.pickupOnly ? '<div class="so-dsheet__msg">' + ico('info') + '<p>' + esc(m.pickupOnly) + '</p></div>' : '') +
      (m.preorder ? '<p class="so-dsheet__po">' + (m.preorderDates ? esc(m.preorder).replace(esc(m.preorderDates), '<b>' + esc(m.preorderDates) + '</b>') : esc(m.preorder)) + '</p>' : '') +
      '<ul class="so-dsheet__opts" aria-label="Delivery options at ' + esc(code) + '">' + m.rows.map(function (r) { return rowHtml(r, code); }).join('') + '</ul>' +
      '<p class="so-dsheet__pick">You choose one at checkout.</p>' +
      (m.discountLine ? '<p class="so-dsheet__disc">' + esc(m.discountLine) + '</p>' : '') +
      '<p class="so-dsheet__note">' + esc(m.foot) + '</p></div>');
    if (announce) say('Showing ' + m.rows.length + ' delivery option' + (m.rows.length === 1 ? '' : 's') + ' for ' + code + '.');
  }

  // ---- the sheet's pinned next-step footer (Task 13) ----
  // Below the scrolling body (outside .so-dsheet__content, so paint() never replaces it): shown in the delivery
  // view (every state: figures, loading, failed), hidden in the postcode view. Buttons from sheetFooterModel:
  // cart origins / on /cart → "Back to cart"; elsewhere "Continue shopping" (+ "View cart · R887" when the
  // cart has items, read once per open from /cart.js — nothing shows until that read settles).
  function onCartPage() { return /\/cart\/?$/.test(location.pathname); }
  function readCart() {
    if (!sh) return cartInfo();
    if (!sh.cartP) {
      var mine = sh;
      mine.cartP = cartInfo().then(function (c) {
        if (sh === mine && c) { mine.cart = { count: c.count, total: c.total }; renderFoot(); }   // a failed read keeps the seed
        return c;
      });
    }
    return sh.cartP;
  }
  function footBtn(b) {
    return '<button type="button" class="so-dsheet__btn so-dsheet__fbtn' + (b.primary ? '' : ' so-dsheet__btn--ghost') + '" ' +
      (b.act === 'cart' ? 'data-so-dsheet-cart' : 'data-so-dsheet-close') + ' data-k="foot-' + b.act + '"' +
      (b.aria ? ' aria-label="' + esc(b.aria) + '"' : '') + '>' + (b.icon ? ico(b.icon) : '') +
      '<span>' + esc(b.label) + (b.figure ? '<span class="so-dsheet__fig"> · ' + esc(b.figure) + '</span>' : '') + '</span></button>';
  }
  function renderFoot() {
    var f = sh && sh.root.querySelector('[data-so-dsheet-foot]');
    if (!f) return;
    var m = sh.view === 'delivery' ? sheetFooterModel(sh.origin, sh.cart, onCartPage()) : null;
    var code = current(), saved = !!(m && m.saved && sh.saved && code && slotShown());
    var key = m ? JSON.stringify([m.buttons, saved && code]) : '';
    if (f.getAttribute('data-so-foot') === key) return;
    var a = document.activeElement, k = a && f.contains(a) ? a.getAttribute('data-k') : null;
    f.setAttribute('data-so-foot', key);
    f.innerHTML = !m ? '' : (saved ? '<p class="so-dsheet__done">' + ico('check') + '<span>Saved on this device <span class="so-dsheet__done-m">· the header now shows</span> ' + chip(code) + '</span></p>' : '') +
      '<div class="so-dsheet__acts' + (m.buttons.length > 1 ? ' is-two' : '') + '">' + m.buttons.map(footBtn).join('') + '</div>';
    f.hidden = !m;
    if (k) {                                               // a re-render keeps focus on the same button, else the title
      var to = f.querySelector('[data-k="' + k + '"]') || sh.content.querySelector('#so-dsheet-title');
      if (to) to.focus({ preventScroll: true });
    }
  }
  // "View cart": close the sheet (no focus return — the drawer takes focus) and open the theme's cart drawer
  // the way its own code does (cart-drawer.js listens for dispatch:cart-drawer:open); no drawer → /cart.
  function viewCart() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) { closeSheet(); window.location.href = (window.routes && window.routes.cart_url) || '/cart'; return; }
    closeSheet(true);
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { detail: { opener: document.getElementById('cart-icon') } }));
  }
  // Callers name their origin; an external caller that doesn't (so-pdp-info.js) is 'cart' when its opener sits in
  // a cart, else 'page'.
  function originOf(opts) {
    if (opts.origin) return String(opts.origin);
    var rf = opts.returnFocus;
    return rf && rf.nodeType === 1 && rf.closest('cart-drawer, [data-so-cart-delivery], [data-so-cart-addons], [data-so-cart-empty]') ? 'cart' : 'page';
  }

  function open(which, opts) {
    opts = opts || {};
    alive();
    // The phase-2 "How delivery is priced" modal (so-cart-delivery.js) pulls focus back into itself on
    // focusin; close it first so the two dialogs never fight over focus.
    var cdm = document.querySelector('body > .so-cart-delivery-modal .so-modal__close[data-so-close]');
    if (cdm) { cdm.click(); if (!opts.returnFocus) opts.returnFocus = document.activeElement; }
    var first = !sh;
    openSheet(null, opts.returnFocus);
    // No basis passed (bar, PDP card before its figure): the visible cart row's basis and pre-order state;
    // only with no cart block on the page does the sheet read /cart.js itself (sh.basis null).
    var vc = typeof opts.basis === 'number' && typeof opts.preorder === 'boolean' ? null : visibleCart();
    var b = typeof opts.basis === 'number' && opts.basis >= 0 ? opts.basis : vc ? vc.basis : null;
    if (first || b != null) sh.basis = b;
    sh.preorder = typeof opts.preorder === 'boolean' ? opts.preorder : vc ? vc.preorder : false;
    if (first || opts.origin) sh.origin = originOf(opts);
    if (CART_ORIGINS.indexOf(sh.origin) < 0 && !onCartPage()) readCart();   // the footer's "View cart · R…"
    var willShow = which === 'delivery' && current() ? 'delivery' : 'postcode';
    var t = TR(); if (t) { t.send('sheet_open', { code: willShow }); t.clarityEvent('so_sheet_open'); }
    if (willShow === 'delivery') showDelivery(false); else showPostcode();
    if (which === 'delivery' && current()) {
      var t = sh.content.querySelector('#so-dsheet-title'); if (t) t.focus({ preventScroll: true });
    }
  }

  window.soDelivery = { config: cfgOnce, postcode: current, place: currentPlace, quote: curQuote, summary: summary, open: open, on: on };

  // ---- announcement bar (sections/announcement.liquid, unchanged) ----
  // Known postcode + a quote for it: a plain div.announcement.so-announce with the same classes and colours
  // covers the <announcement-bar>, holding one button ("Delivering to [7441] · Order by 7 AM Mon · Same Day Mon")
  // and a copy of the right-hand links. The original stays in the DOM and in flow but invisible (both share
  // one grid cell of the section, so-delivery-sheet.css), so the bar keeps its exact height at every width —
  // no layout shift, and main.js's --header-height stays right. Not detaching it keeps announcement.js's
  // breakpoint link-mover bound, so restoring puts the bar back exactly as it was; its rotation carries on
  // unseen meanwhile. Anything else (no postcode, lookup pending, failed, no options, no config): the original
  // bar exactly as rendered — Charl's rotating messages, untouched (Task 13: the postcode entry point is the
  // header slot now, so the bar carries no link).
  var annOrig = null, annNode = null;
  function annBar() {
    if (!annOrig || !annOrig.isConnected) annOrig = document.querySelector('announcement-bar');
    return annOrig;
  }
  function renderBar() {
    var b = annBar();
    if (!b) { if (annNode) { annNode.remove(); annNode = null; } return; }
    // The cart basis the slot and the footer use: the visible cart block's, else /cart.js (read by the slot).
    var code = current(), vc = code ? visibleCart() : null, bb = vc ? vc.basis : slotCart != null && slotCart >= 0 ? slotCart : null;
    var m = code ? announceModel(summary(bb == null ? 0 : bb), cfgOnce(), code, Date.now(),
                                 { preorder: !!(vc && vc.preorder), basisUnknown: bb == null }) : null;
    annClock(!!m);
    if (!m) {                                           // restore the bar exactly as rendered
      if (annNode) { annNode.remove(); annNode = null; }
      if (b.hasAttribute('data-so-announce-hid')) { b.removeAttribute('data-so-announce-hid'); b.parentNode.classList.remove('so-announce-host'); }
      annTap(b);
      return;
    }
    var key = code + '|' + m.text + '|' + m.short;
    if (annNode && annNode.isConnected && annNode.nextElementSibling === b && annNode.getAttribute('data-so-announce') === key) return;
    var n = document.createElement('div');
    n.className = b.className + ' so-announce';
    n.setAttribute('data-so-announce', key);
    n.innerHTML = '<div class="container"><div class="flex"><div class="announcement__col--left announcement__col--align-center">' +
      '<div class="announcement__text flex items-center m-0">' +
      '<button type="button" class="so-announce__btn" data-so-announce-open aria-haspopup="dialog" aria-label="' + esc(m.aria) + '">' +
      ico('pin', 'so-announce__i so-announce__pin') +
      '<span class="so-announce__t" aria-hidden="true"><span class="so-announce__lead">Delivering to ' + chip(code) + ' ·&nbsp;</span>' +
      '<span class="so-announce__x"><span class="so-announce__full">' + esc(m.text) + '</span><span class="so-announce__short">' + esc(m.short) + '</span></span></span>' +
      ico('chev', 'so-announce__i so-announce__chev') + '</button></div></div></div></div>';
    var right = b.querySelector('.announcement__col--right');
    if (right) {                                        // the links only: a localisation form must not be duplicated
      var r = right.cloneNode(true);
      r.querySelectorAll('.announcement__localization').forEach(function (x) { x.remove(); });
      n.querySelector('.flex').appendChild(r);
    }
    if (annNode) annNode.remove();
    b.parentNode.insertBefore(n, b);
    annNode = n;
    b.setAttribute('data-so-announce-hid', '');
    b.parentNode.classList.add('so-announce-host');
  }
  // No postcode yet (or no quote for it): Charl's rotating messages stay exactly as written, and the whole bar
  // becomes the way in — tap it to open the postcode sheet (a small "›" beside the slider says so on phones;
  // desktop also has the header slot). A link inside a slide keeps working. The chevron sits OUTSIDE the slider
  // (a horizontal scroller that would carry it away with the slides).
  var ANN_TAP_LABEL = 'See delivery options for your area';
  function annTap(b) {
    if (b.__soTap) return;
    var col = b.querySelector('.announcement__col--left');
    if (!col) return;
    b.__soTap = true;
    b.classList.add('so-announce-tap');
    col.setAttribute('role', 'button');
    col.setAttribute('tabindex', '0');
    col.setAttribute('aria-label', ANN_TAP_LABEL);
    col.setAttribute('aria-haspopup', 'dialog');
    var chev = document.createElement('span');
    chev.className = 'so-announce-tap__chev';
    chev.setAttribute('aria-hidden', 'true');
    chev.innerHTML = ico('chev', 'so-announce__i so-announce__chev');
    col.parentNode.insertBefore(chev, col.nextSibling);
    function go(e) {
      if (b.hasAttribute('data-so-announce-hid')) return;   // a quote's bar covers it (it has its own button)
      if (e.target && e.target.closest && e.target.closest('a, button, input, select, form')) return;
      e.preventDefault();
      var t = TR(); if (t) t.clarityEvent('so_bar_tap');
      open(current() ? 'delivery' : 'postcode', {});
    }
    b.addEventListener('click', go);
    col.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') go(e); });
  }

  // Day-aware text: ONE timeout to the next cut-off or SAST midnight (whichever comes first), re-armed by the
  // render it triggers; renderBar only touches the DOM when the text changed. Tab return re-checks at once
  // (background timers may be throttled). No bar (no model) → no timer.
  var annTimer = null;
  function annClock(on) {
    if (annTimer) { clearTimeout(annTimer); annTimer = null; }
    if (!on || !cfgOnce()) return;
    var now = Date.now();
    annTimer = setTimeout(function () { annTimer = null; renderBar(); }, nextBoundary(now, cfgOnce()) - now + 1000);
  }
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible' && annTimer) renderBar(); });
  // Focus after a sheet opened from the bar closes: the bar's button if it is still showing, else the header slot.
  function barFocus() {
    return (annNode && annNode.isConnected && annNode.querySelector('[data-so-announce-open]')) || slotFocus();
  }
  // Opens with no basis: the sheet reads the cart's subtotal from /cart.js itself (and shows its "couldn't load"
  // state with Try again if that fails), so the tap never waits on the network.
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-so-announce-open]');
    if (!t) return;
    e.preventDefault();
    open('delivery', { origin: 'bar', returnFocus: barFocus });
  });
  on(renderBar);
  // A postcode saved or cleared in another tab: follow it here too (bar, cart rows, every subscriber).
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY && e.key !== null) return;
    var c = current();
    fillAll(); renderBar(); renderPdp(); renderSlot();
    if (c && isPending(c)) fetchQuote(c).then(function () { if (current() === c) emit(); }); else emit();
  });

  // ---- header postcode slot (snippets/so-postcode-slot.liquid, rendered in sections/header.liquid; Task 13) ----
  // Liquid renders a visible LINK to /pages/delivery-locations in the no-postcode state (Ruling 22: in the first
  // paint, so no layout shift, and it works with no JS, no config or this script failing). Here: once the config
  // parses, swap it for a <button> in the same box (slotUpgrade), then keep ONE state from slotModel on every
  // [data-so-slot] button (the DOM is only touched when the state key changes). Cart basis: the visible
  // cart block's (the drawer is on every page), else /cart.js — read once, again on cart events and when the
  // header's cart bubble re-renders. Line 2 has no day words (Task 14), so no clock.
  var SLOT_SEEN = 'soSlotPulseSeen', slotCart = null, slotSeq = 0, slotReading = false, slotBlocks = null;
  function slotEls() { return document.querySelectorAll('[data-so-slot]'); }
  function slotFocus() {
    var els = slotEls();
    for (var i = 0; i < els.length; i++) if (els[i].tagName === 'BUTTON' && els[i].getClientRects().length) return els[i];
    return null;
  }
  function slotShown() { return !!slotFocus(); }
  // Liquid renders an <a href="/pages/delivery-locations"> (works with no JS, same box → no layout shift). Once the
  // config parses it becomes a <button> that opens the sheets, once; the first-visit pulse runs then.
  function slotUpgrade(a) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = a.className;
    btn.setAttribute('data-so-slot', '');
    btn.setAttribute('aria-haspopup', 'dialog');
    btn.innerHTML = a.innerHTML;
    var had = document.activeElement === a;
    a.parentNode.replaceChild(btn, a);
    if (had) btn.focus({ preventScroll: true });
    var fresh = false;
    try { fresh = !localStorage.getItem(SLOT_SEEN); if (fresh) localStorage.setItem(SLOT_SEEN, '1'); } catch (e) { fresh = false; }
    if (fresh) { btn.classList.add('is-pulse'); setTimeout(function () { btn.classList.remove('is-pulse'); }, 4000); }
    return btn;
  }
  function slotRead() {
    var seq = ++slotSeq;
    slotReading = true;
    cartBasis().then(function (b) { if (seq !== slotSeq) return; slotReading = false; slotCart = b; renderSlot(); renderBar(); });
  }
  function slotHtml(m) {
    var l2 = m.line == null ? '<span class="so-slot__l2 is-load"></span>'
      : '<span class="so-slot__l2' + (m.free ? ' is-free' : m.state === 'none' ? ' is-go' : '') + '">' + (m.free ? ico('check', 'so-slot__ok') : '') +
        '<span class="so-slot__s">' + esc(m.line) + '</span><span class="so-slot__lg">' + esc(m.long) + '</span></span>';
    return '<span class="so-slot__pin" aria-hidden="true">' + ico('pin', 'so-slot__pi') + '</span>' +
      '<span class="so-slot__tx" aria-hidden="true"><span class="so-slot__l1"><span class="so-slot__dt">Delivery to</span>' +
      '<span class="so-slot__tg' + (m.empty ? ' is-empty' : '') + '">' + esc(m.tag) + '</span></span>' + l2 + '</span>';
  }
  // Desktop-only breakpoint (so-postcode-slot.css: the slot is hidden below 769px). Below it, renderSlot() must
  // not fetch /cart.js (slotRead → cartBasis) or upgrade the Liquid link to a <button> (slotUpgrade), which would
  // also consume the one-time first-visit pulse before the customer ever sees a desktop slot.
  function slotDesktop() { try { return !!(window.matchMedia && window.matchMedia('(min-width: 769px)').matches); } catch (e) { return false; } }
  function renderSlot() {
    var els = slotEls();
    if (!els.length || !slotDesktop()) return;
    var cfg = cfgOnce();
    if (!cfg) return;                                          // no config: the Liquid link to /pages/delivery-locations stays
    var code = current(), q = curQuote(), lookup = null, s = null, pre = false;
    if (code) {
      if (failed(code)) lookup = 'failed';
      else if (!q) lookup = 'pending';
      else if (isUnconfirmed(q)) lookup = 'unconfirmed';
      else {
        var vc = visibleCart(), b = vc ? vc.basis : slotCart;
        if (b == null) { lookup = 'pending'; if (!slotReading) slotRead(); }
        else if (b < 0) lookup = 'failed';
        else { s = summarise(q, b, cfg.ladder); pre = vc ? vc.preorder : false; }
      }
    }
    var m = slotModel(code, lookup, s, cfg, Date.now(), { preorder: pre });
    var key = [m.state, m.tag, m.line, m.long, m.free].join('|');
    Array.prototype.forEach.call(els, function (el) {
      if (el.tagName !== 'BUTTON') el = slotUpgrade(el);
      if (el.getAttribute('data-so-slot-done') === key) return;
      el.setAttribute('data-so-slot-done', key);
      el.innerHTML = slotHtml(m);
      el.setAttribute('aria-label', m.aria);
      el.setAttribute('data-so-slot-state', m.state);
    });
  }
  function slotGlow() {
    Array.prototype.forEach.call(slotEls(), function (el) {
      el.classList.remove('is-glow'); void el.offsetWidth; el.classList.add('is-glow');
      setTimeout(function () { el.classList.remove('is-glow'); }, 1600);
    });
  }
  // Cart changed: the theme's events carry the new cart → use it; otherwise re-read (only once read before).
  function slotCartChanged(e) {
    if (!slotEls().length) return;
    var c = e && e.detail && e.detail.cart;
    if (c && typeof c.items_subtotal_price === 'number') {
      lastCartFull = c;   // Task 28: the theme's own cart event already carries the full cart (incl. attributes)
      if (typeof c.item_count === 'number') lastCart = { count: c.item_count, total: typeof c.total_price === 'number' ? c.total_price / 100 : null };
      ++slotSeq; slotReading = false; slotCart = c.items_subtotal_price / 100; renderSlot(); renderBar(); return;
    }
    if (slotCart != null || slotReading) slotRead();
  }
  // Per DOM mutation: only attribute reads on the (few) cart delivery blocks; re-render only when one changed.
  function slotBlocksChanged() {
    var sig = Array.prototype.map.call(document.querySelectorAll('[data-so-cart-delivery]'), function (b) {
      return (b.hidden ? 'h' : '') + b.getAttribute('data-so-cd-basis') + (b.getAttribute('data-so-cd-variant') || '');
    }).join(',');
    if (sig === slotBlocks) return false;
    slotBlocks = sig;
    return true;
  }
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('button[data-so-slot]');   // the no-JS link stays a link
    if (!el) return;
    e.preventDefault();
    open(current() ? 'delivery' : 'postcode', { origin: 'header', returnFocus: el });
  });
  ['on:cart:add', 'on:line-item:change', 'cart:refresh', 'on:cart:change', 'cart:updated', 'dispatch:cart-drawer:refresh']
    .forEach(function (ev) { document.addEventListener(ev, slotCartChanged); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) slotCartChanged(); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') slotCartChanged(); });
  on(renderSlot);

  // ---- product page (snippets/so-pdp-info.liquid card + sections/main-product.liquid line) ----
  // Card label [data-so-pdp-delivery] + its link line: the state from pdpCardModel (no postcode → "Your delivery price" ·
  // "Add postcode"; pending → "Your delivery price" · "Options to [7441]"; failed / no options → "Delivery to [7441]" ·
  // "Change postcode"; quote → ONE line "Delivery from R19" or (something free) "Pickup is free" in the saved green ·
  // "Options to [7441]"). The label keeps the reserved 2-line box, so the card is exactly its siblings' height. No config
  // (or no JS) → the Liquid label and link line exactly as rendered ("Delivery from R73" / "Rates & collection") and
  // the old modal. so-pdp-info.js opens the postcode sheet from the card with no postcode, else the delivery sheet
  // with the basis we put on the button (data-so-pdp-basis, quote state only; absent → the sheet reads /cart.js itself).
  // Line [data-so-pdp-with]: "With this, your cart is R887: Pickup to [7441] becomes free (R19 now)" — shown
  // only when withThisModel says an option newly becomes free with the selected variant added; else hidden.
  // The cart subtotal is read from /cart.js lazily (only once there is a quote to price) and again on the
  // theme's cart events; while a re-read is in flight the line is hidden (it would count the old cart).
  var pdpCart = null, pdpSeq = 0, pdpPending = false, pdpStale = false;   // pdpCart: rands, -1 = read failed
  function pdpRead() {
    var seq = ++pdpSeq;
    pdpPending = true;
    cartBasis().then(function (b) {
      if (seq !== pdpSeq) return;
      pdpPending = false; pdpStale = false; pdpCart = b; renderPdp();
    });
  }
  // Never inside the quick-add drawer (quick-add.js copies a product form's innerHTML into it).
  function pdpOwn(sel) {
    return Array.prototype.filter.call(document.querySelectorAll(sel), function (n) { return !n.closest('quick-add-drawer'); });
  }
  function pdpScope(n) { return n.closest('.product, .js-product') || document; }
  // Memo of everything the output depends on: the observer calls this on every DOM mutation, so return
  // before any summarise() when nothing changed and every node already carries its rendered key.
  var pdpMemo = { q: null, sig: null };
  function renderPdp() {
    var labels = pdpOwn('[data-so-pdp-delivery]'), lines = pdpOwn('[data-so-pdp-with]');
    if (!labels.length && !lines.length) return;
    var code = current(), q = curQuote(), cfg = cfgOnce();
    if (code && q && cfg && pdpCart == null && !pdpPending) pdpRead();
    // The card's figure (and the basis its sheet opens with): the visible cart row's basis when a cart block is on
    // the page (e.g. /cart, a mixed pre-order cart with Remove chosen → the in-stock amount), else /cart.js.
    // The "with this" line keeps the whole-cart /cart.js amount (it adds this item to the whole cart).
    var vc = labels.length ? visibleCart() : null;
    var cardBasis = vc ? vc.basis : pdpCart, cardFresh = vc ? true : pdpCart >= 0 && !pdpStale;
    var sig = [code, failed(code) ? 'x' : '', hasQuote(code) ? quoteFor : '', pdpCart, pdpStale, !!cfg, labels.length, vc ? vc.basis : '-'].concat(lines.map(function (l) {
      return l.getAttribute('data-price') + '/' + l.getAttribute('data-available') + '/' + pdpQty(l);
    })).join('|');
    var fresh = labels.concat(lines).every(function (n) { return n.hasAttribute('data-so-pdp-done'); });
    if (fresh && pdpMemo.q === q && pdpMemo.sig === sig) return;
    pdpMemo.q = q; pdpMemo.sig = sig;
    var ok = !!(code && q && cfg && pdpCart != null && pdpCart >= 0);
    // State choice lives in pdpCardModel; here only: failed lookup / pending (quote in flight, or no cart basis yet).
    var lookup = !code ? null : failed(code) ? 'failed' : isUnconfirmed(q) ? 'unconfirmed' : !q || !(cardBasis != null && cardBasis >= 0) ? 'pending' : null;
    var card = pdpCardModel(lookup || !q || !cfg ? null : summarise(q, cardBasis, cfg.ladder), cfg, code, lookup);
    labels.forEach(function (lab) {
      var btn = lab.closest('button');
      if (btn) { if (cardFresh && card && card.state === 'ok') btn.setAttribute('data-so-pdp-basis', String(cardBasis)); else btn.removeAttribute('data-so-pdp-basis'); }
      var key = card ? [card.state, code, card.label, card.cue].join('|') : '';
      if (lab.getAttribute('data-so-pdp-done') === key) return;
      lab.setAttribute('data-so-pdp-done', key);
      if (lab.__soOrig == null) lab.__soOrig = lab.innerHTML;
      var cue = btn && btn.querySelector('.usp-card__cue');
      if (cue && cue.__soOrig == null) cue.__soOrig = cue.innerHTML;
      if (!card) {                                   // no config: the Liquid card exactly as rendered (+ the old modal)
        lab.innerHTML = lab.__soOrig; lab.classList.remove('is-pc', 'is-free');
        if (cue) { cue.innerHTML = cue.__soOrig; cue.classList.remove('is-pc'); }
        if (btn) btn.removeAttribute('aria-label');
        return;
      }
      lab.innerHTML = esc(card.label) + (card.labelChip ? ' ' + chip(code) : '');
      lab.classList.add('is-pc'); lab.classList.toggle('is-free', card.free);
      if (cue) { cue.innerHTML = card.cueChip ? '<span>' + esc(card.cue) + '</span> ' + chip(code) : esc(card.cue); cue.classList.add('is-pc'); }
      if (btn) btn.setAttribute('aria-label', card.aria);
    });
    lines.forEach(function (line) {
      var price = parseInt(line.getAttribute('data-price'), 10) / 100;          // cents → rands
      var m = ok && !pdpStale && line.getAttribute('data-available') !== 'false' && price > 0
        ? withThisModel(q, pdpCart, pdpCart + price * pdpQty(line), cfg) : null;
      var key = m ? [code, m.name, m.total, m.now].join('|') : '';
      if (line.getAttribute('data-so-pdp-done') === key) return;
      line.setAttribute('data-so-pdp-done', key);
      if (!m) { line.hidden = true; line.textContent = ''; return; }
      line.innerHTML = ico('check', 'so-pdp-with__i') + '<span class="so-pdp-with__t">With this, <span class="so-pdp-with__cart">your cart is ' +
        esc(m.total) + ': </span><b class="so-pdp-with__g">' + esc(m.name) + '<span class="so-pdp-with__to"> to ' + chip(code) + '</span> becomes free</b> <span class="so-pdp-with__m">(' + esc(m.now) + ' now)</span></span>';
      line.hidden = false;
    });
  }
  // "This" = what Add to cart adds: the variant price × the form's quantity (pack products start at 10).
  function pdpQty(line) {
    var scope = pdpScope(line);
    var qi = scope.querySelector('.js-product-form-main [name="quantity"]') || scope.querySelector('input[name="quantity"]');
    var n = qi ? parseInt(qi.value, 10) : 1;
    return n >= 1 ? n : 1;
  }
  function pdpQtyChanged(e) {
    var t = e.target;
    if (t && t.name === 'quantity' && document.querySelector('[data-so-pdp-with]')) renderPdp();
  }
  document.addEventListener('change', pdpQtyChanged);
  // Variant change (variant-picker.js, the same event so-sticky-atc listens to): only this product's picker.
  document.addEventListener('on:variant:change', function (e) {
    var v = e.detail && e.detail.variant, hit = false;
    if (e.target && e.target.closest && e.target.closest('quick-add-drawer')) return;
    pdpOwn('[data-so-pdp-with]').forEach(function (line) {
      var scope = pdpScope(line);
      if (!e.target || !scope.contains(e.target)) return;
      hit = true;
      if (v && v.price != null) line.setAttribute('data-price', String(v.price));
      line.setAttribute('data-available', v && v.available ? 'true' : 'false');
    });
    if (hit) renderPdp();
  });
  // Cart changes: the theme's events carry the new cart (product-form.js, cart-items.js) → use it at once;
  // the rest (so-preorder-cart's list, drawer refresh, back/forward, tab return) → re-read /cart.js.
  function pdpCartChanged(e) {
    if (!document.querySelector('[data-so-pdp-delivery], [data-so-pdp-with]')) return;
    var c = e && e.detail && e.detail.cart;
    if (c && typeof c.items_subtotal_price === 'number') { ++pdpSeq; pdpPending = false; pdpStale = false; pdpCart = c.items_subtotal_price / 100; renderPdp(); return; }
    if (pdpCart == null && !pdpPending) return;          // never read (no quote yet): nothing to refresh
    pdpStale = true; pdpRead(); renderPdp();
  }
  ['on:cart:add', 'on:line-item:change', 'cart:refresh', 'on:cart:change', 'cart:updated', 'dispatch:cart-drawer:refresh']
    .forEach(function (ev) { document.addEventListener(ev, pdpCartChanged); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) pdpCartChanged(); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') pdpCartChanged(); });
  on(renderPdp);

  // Synchronous (no debounce): observer callbacks run as a microtask before the next paint, so a
  // re-rendered cart block is refilled before the national Liquid row can flash. No loop: fill()
  // only touches the DOM when a block's data-so-pc-done key changes, so the mutations it causes
  // re-enter fillAll() and return early on every block.
  // The header cart bubble is re-rendered by every cart change, including the silent ones that fire no theme
  // event (FBT, cart add-ons, pre-order trim): re-read the PDP cart basis then.
  new MutationObserver(function (ms) {
    alive(); fillAll();
    var bubble = document.getElementById('cart-icon-bubble');
    var hit = bubble && ms.some(function (m) { return bubble.contains(m.target); });
    if (hit) pdpCartChanged(); else renderPdp();
    if (hit) slotCartChanged();
    if (slotBlocksChanged()) { renderSlot(); renderBar(); }   // slot + bar follow the visible cart block (basis, pre-order kept)
  }).observe(document.documentElement, { childList: true, subtree: true });
  // The cart drawer opens/closes by its `open` attribute (side-drawer.js): that is when the one-time pop-over
  // may show (first open with no postcode) or goes away (drawer closed).
  new MutationObserver(function (ms) {
    if (ms.some(function (m) { return m.target.tagName === 'CART-DRAWER'; })) { invite(); fillCutoff(); }   // + start/stop the card clock
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['open'], subtree: true });
  on(function () { fillAll(); });                  // a postcode set anywhere (sheet, bar) removes the pop-over
  // + the product page card once at load: with no postcode nothing else emits, and its "Prices for your area" link
  // line must not wait for an unrelated DOM mutation (Task 12).
  function boot() {
    fillAll(); renderPdp(); slotBlocksChanged(); renderSlot(); signInReturn();
    var t = TR(); if (t) t.claritySet(!!current());   // contract D: clarity('set','so_pc', …) once, on boot
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // Crossing the 769px breakpoint (rotation, resize, devtools): renderSlot() re-checks slotDesktop() itself, but
  // it only touches the DOM on a changed state key — call it again so a phone→desktop cross fills the slot at once.
  try {
    if (window.matchMedia) {
      var slotMq = window.matchMedia('(min-width: 769px)');
      var onSlotMq = function () { renderSlot(); };
      if (slotMq.addEventListener) slotMq.addEventListener('change', onSlotMq);
      else if (slotMq.addListener) slotMq.addListener(onSlotMq);   // older Safari
    }
  } catch (e) { /* matchMedia unsupported: slot stays whatever boot() rendered */ }
})();
